import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError, change, initialize } from 'redux-form';
import { toFromDates, convertUtcDate } from '../components/Common/cleanDates';
import moment from 'moment';

import {
  REQUEST_SALES_ORDERS,
  FETCH_SALES_ORDERS_SUCCESS,
  FETCH_SALES_ORDERS_FAILURE,
  REQUEST_CUSTOMER_PRICES,
  FETCH_CUSTOMER_PRICES_SUCCESS,
  FETCH_CUSTOMER_PRICES_FAILURE,
  SELECT_SALES_ORDER,
  RESET_CURRENT_SALES_ORDER,
  REQUEST_SALES_ORDER_DETAIL,
  FETCH_SALES_ORDER_DETAIL_SUCCESS,
  FETCH_SALES_ORDER_DETAIL_FAILURE,
  REQUEST_CREATING_SALES_ORDER,
  CREATE_SALES_ORDER_SUCCESS,
  CREATE_SALES_ORDER_FAILURE,
  REQUEST_EDITING_SALES_ORDER,
  EDIT_SALES_ORDER_SUCCESS,
  EDIT_SALES_ORDER_FAILURE,
  REQUEST_VOID_SALES_ORDER,
  VOID_SALES_ORDER_SUCCESS,
  VOID_SALES_ORDER_FAILURE,
  REQUEST_CUSTOMER_SALES_HISTORY,
  FETCH_CUSTOMER_SALES_HISTORY_SUCCESS,
  FETCH_CUSTOMER_SALES_HISTORY_FAILURE,
  REQUEST_CUSTOMER_ORDER_SCHEDULES,
  FETCH_CUSTOMER_ORDER_SCHEDULES_SUCCESS,
  FETCH_CUSTOMER_ORDER_SCHEDULES_FAILURE,
  REQUEST_TODAYS_OUTGOING_ORDERS,
  FETCH_TODAYS_OUTGOING_ORDERS_SUCCESS,
  FETCH_TODAYS_OUTGOING_ORDERS_FAILURE,
  REQUEST_SALES_ORDER_LINE_WEIGHTS,
  FETCH_SALES_ORDER_LINE_WEIGHTS_SUCCESS,
  FETCH_SALES_ORDER_LINE_WEIGHTS_FAILURE,
  REQUEST_SET_ORDER_LINE_WEIGHTS,
  EDIT_SALES_ORDER_LINE_WEIGHTS_SUCCESS,
  EDIT_SALES_ORDER_LINE_WEIGHTS_FAILURE,
  CLEAR_SALES_ORDER_LINE_WEIGHTS,
  REQUEST_SALES_ORDER_FORM,
  FETCH_SALES_ORDER_FORM_SUCCESS,
  FETCH_SALES_ORDER_FORM_FAILURE,
  CLEAR_INVENTORIES,
  REQUEST_SALES_CSV,
  FETCH_SALES_CSV_SUCCESS,
  FETCH_SALES_CSV_FAILURE,
  REQUEST_SAVE_POS_SALE,
  SAVE_POS_SALE_SUCCESS,
  SAVE_POS_SALE_FAILURE,
  INVALID_CHARACTER_ENTERED,
  CLEAR_ERROR_MESSAGE_IN_POS,
  CHARGE_NOT_MET,
  START_NEW_ORDER,
  REQUEST_DRAFT_DETAILS,
  LOAD_DRAFT_SUCCESS,
  LOAD_DRAFT_FAILURE,
  REQUEST_DRAFTS,
  FETCH_DRAFTS_SUCCESSFUL,
  FETCH_DRAFTS_FAILURE,
  REQUEST_CREATING_SALES_RETURN,
  CREATE_SALES_RETURN_SUCCESS,
  CREATE_SALES_RETURN_FAILURE,
  REQUEST_SALES_RETURN_DETAIL,
  FETCH_SALES_RETURN_DETAIL_SUCCESS,
  FETCH_SALES_RETURN_DETAIL_FAILURE,
  REQUEST_INVENTORY_RETURN,
  FETCH_INVENTORY_RETURN_SUCCESS,
  FETCH_INVENTORY_RETURN_FAILURE,
  REQUEST_INVENTORY_RETURN_DETAILS,
  FETCH_INVENTORY_RETURN_DETAILS_SUCCESS,
  FETCH_INVENTORY_RETURN_DETAILS_FAILURE,
  EDIT_INVENTORY_RETURN,
  EDIT_INVENTORY_RETURN_SUCCESS,
  EDIT_INVENTORY_RETURN_FAILURE,
  REQUEST_CURRENCY_RATES,
  FETCH_CURRENCY_RATES_SUCCESS,
  FETCH_CURRENCY_RATES_FAILURE,
  EDIT_MULTI_CURRENCIES,
  EDIT_MULTI_CURRENCIES_SUCCESS,
  EDIT_MULTI_CURRENCIES_FAILURE,
  REQUEST_TAX_RATES,
  FETCH_TAX_RATES_SUCCESS,
  FETCH_TAX_RATES_FAILURE,
  REQUEST_CREATE_TAX_RATE,
  CREATE_TAX_RATE_SUCCESS,
  CREATE_TAX_RATE_FAILURE,
  EDIT_MULTI_TAXES,
  EDIT_MULTI_TAXES_SUCCESS,
  EDIT_MULTI_TAXES_FAILURE,
  DELETE_TAX,
  DELETE_TAX_SUCCESS,
  DELETE_TAX_FAILURE,
  REQUEST_OVERALL_SALES_PERFORMANCE,
  FETCH_OVERALL_SALES_PERFORMANCE_SUCCESS,
  FETCH_OVERALL_SALES_PERFORMANCE_FAILURE,
  REQUEST_POS_REPORT,
  FETCH_POS_REPORT_SUCCESS,
  FETCH_POS_REPORT_FAILURE,
  REQUEST_SALES_INVENTORY_INFO,
  FETCH_SALES_INVENTORY_INFO_SUCCESS,
  FETCH_SALES_INVENTORY_INFO_FAILURE,
  REQUEST_SALES_CUSTOMER_DETAIL,
  FETCH_SALES_CUSTOMER_DETAIL_SUCCESS,
  FETCH_SALES_CUSTOMER_DETAIL_FAILURE,
  REQUEST_SHIPPING_DETAIL,
  FETCH_SHIPPING_DETAIL_SUCCESS,
  FETCH_SHIPPING_DETAIL_FAILURE,
  REQUEST_PURCHASES_VENDOR_DETAIL,
  FETCH_PURCHASES_VENDOR_DETAIL_SUCCESS,
  FETCH_PURCHASES_VENDOR_DETAIL_FAILURE,
  REQUEST_ITEM_SALES_HISTORY,
  FETCH_ITEM_SALES_HISTORY_SUCCESS,
  FETCH_ITEM_SALES_HISTORY_FAILURE,
  REQUEST_CUSTOMER_FREQUENT,
  FETCH_CUSTOMER_FREQUENT_SUCCESS,
  FETCH_CUSTOMER_FREQUENT_FAILURE,
  CLEAR_SALES_CUSTOMER_DETAILS,
  SET_SALES_ORDERS_FILTER,
  REQUEST_SALES_PERFORMANCE,
  REQUEST_SALES_PERFORMANCE_SUCCESS,
  REQUEST_SALES_PERFORMANCE_FAILURE,
  REQUEST_SALES_DASHBOARD_DETAIL,
  FETCH_SALES_DASHBOARD_DETAIL_SUCCESS,
  FETCH_SALES_DASHBOARD_DETAIL_FAILURE,
  REQUEST_SALES_LEVELS,
  FETCH_SALES_LEVELS_SUCCESS,
  FETCH_SALES_LEVELS_FAILURE,
  REQUEST_REFUND,
  REQUEST_REFUND_SUCCESS,
  REQUEST_REFUND_FAILURE,
  REQUEST_RETURN_VOID,
  REQUEST_RETURN_COMPLETE,
  FETCH_RETURN_SUCCESS,
  FETCH_RETURN_FAILURE,
  REQUEST_SHIPPING_LIST_PDF,
  FETCH_SHIPPING_LIST_SUCCESS,
  REQUEST_PACKING_LIST_PDF,
  FETCH_PACKING_LIST_SUCCESS,
  REQUEST_SO_PDF,
  FETCH_SO_PDF_SUCCESS,
  REQUEST_SO_SI_PDF,
  FETCH_SO_SI_PDF_SUCCESS,
  REQUEST_BOL_ID_PDF,
  FETCH_BOL_ID_PDF_SUCCESS,
  REQUEST_BOL_WITHOUT_LOG,
  FETCH_BOL_WITHOUT_LOG_SUCCESS,
  REQUEST_BOL_LABEL,
  FETCH_BOL_LABEL_SUCCESS,
  REQUEST_BOL_FBA_PDF,
  FETCH_BOL_FBA_PDF_SUCCESS,
  FETCH_BOL_ADDRESS_SUCCESS,

  FETCH_SP_SUCCESS,
  REQUEST_SP_PDF,

  REQUEST_REFUND_PDF,
  REQUEST_REFUND_PDF_SUCCESS,
  REQUEST_PICKING_LIST_PDF,
  FETCH_PICKING_LIST_SUCCESS,
  REQUEST_PRODUCT_BY_ID,
  FETCH_PRODUCT_BY_ID_SUCCESS,
  FETCH_PRODUCT_BY_ID_FAILURE,
  KEEP_EST_DATE,
  FINISHED_UNMOUNT,
  DESTROY_EST_DATE,
  FETCH_SALES_SHIPPING_CUSTOMER_DETAIL_SUCCESS,
  REQUEST_SALES_SHIPPING_CUSTOMER_DETAIL,
  REQUEST_SALES_TOTALS,
  FETCH_SALES_TOTALS_SUCCESS,
  FETCH_SALES_TOTALS_FAILURE,
  REQUEST_SALES_ORDER_DETAIL_BY_NUM,
  FETCH_SALES_ORDER_DETAIL_BY_NUM_SUCCESS,
  FETCH_SALES_ORDER_DETAIL_BY_NUM_FAILURE,
  REQUEST_SALES_ORDER_TO_QUOTE,
  SALES_ORDER_TO_QUOTE_SUCCESS,
  SALES_ORDER_TO_QUOTE_FAILURE,
  REQUEST_SALES_QUOTE_TO_OPEN,
  REQUEST_SALES_QUOTE_TO_ORDER_SUCCESS,
  REQUEST_SALES_QUOTE_TO_ORDER_FAILURE,
  CREATE_MOBILE_TASK,
  CREATE_MOBILE_TASK_SUCCESS,
  CREATE_MOBILE_TASK_FAILURE,
  REQUEST_SET_SHIPPING_WEIGHT,
  UPDATE_SHIPPING_WEIGHT_SUCCESS,
  UPDATE_SHIPPING_WEIGHT_FAILURE,
  REQUEST_SET_SHIPPING_WEIGHT_SPLIT,
  UPDATE_CURRENT_SALES_ORDER_DETAIL_SHIPPINGINFO,
  SALES_ORDER_FORM_BATCHES,
} from './type';

import {
  FETCH_FJ_AGENTS_URL,
  FETCH_FJ_CARRIERS_URL,
  FETCH_FBA_ADDRESS_URL,
  INVENTORIES_URL,
  SALES_ORDERS_URL,
  SALES_QUOTE_URL,
  SALES_ORDERS_REFUND,
  MOBILE_SALES_ORDERS_URL,
  VitAppointmentListOrders_URL,
  SALES_DASHBOARD_URL,
  OUTGOING_ORDERS_BY_DATE_URL,
  SALES_ORDER_LINE_WEIGHTS_URL,
  FETCH_SALES_ORDER_FORM_URL,
  POS_SALE_URL,
  DASHBOARD_URL,
  SALES_RETURN_URL,
  SALES_ISSUE_CREDIT_URL,
  TAX_RATES_URL,
  CURRENCY_RATES_URL,
  OVERALL_SALES_PERFORMANCE_URL,
  POS_REPORT_URL,
  SALES_INVENTORY_INFO_URL,
  SALES_CUSTOMER_URL,
  PURCHASES_VENDOR_URL,
  ITEM_HISTORY_URL,
  FREQUENT_ITEMS_URL,
  INBOUND_PRODUCTS_URL,
  SALES_PERFORMANCE_URL,
  SALES_LOADSPOST_URL,
  SALES_LEVELS_URL,
  SHIPPING_URL,
  SALES_ORDER_PRODUCT_BY_ID_URL,
  SHIPPING_LIST_URL,
  YING_BOL_URL,
  RECEIVING_REPORT_URL,
  YING_CUSTOMER_FILE,
  PICKING_LIST_URL,
  PACKING_LIST_URL,
  REFUND_SUMMARY_URL,
  SALES_ORDER_PRINT_URL,
  QUOTE_TO_ORDER_URL,
  SALES_ORDER_LABEL_PRINT_URL,
  WIZ_PRINT_BOL,
  SALES_ORDER_LABEL_PRINT_URL_BATCH,
  CUSTOMER_SALES_HISTORY,
  PATCH_SALES_ORDER_WEIGHT_URL,
  PATCH_SALES_ORDER_WEIGHT_MULTI_URL,
  PATCH_SALES_EMPLOYEE_NOTE_URL,
  PATCH_SALES_VOID_NOTE_URL,
  FETCH_SALES_ORDER_WEIGHT_TRACKING,
  FETCH_JML_TRACKING_NUMBER_URL,
  PRINT_SHIPPING_LABEL_URL,
  SALES_ORDER_RESHIP_URL,
  CHOWBUS_IMPORT,
  PAYMENT_URL,
  OVERSEA_URL,
  OVERSEA_UPLOAD_BOL_IMAGE_URL,
  OVERSEA_DELETE_BOL_IMAGE_URL,
  OVERSEA_PRINT_BOL_URL,
  SP_PDF_URL,
  OVERSEA_PRINT_BOL_WITHOUT_LOG_URL,
  OVERSEA_PRINT_BOL_LABEL_URL,
  OVERSEA_ADDRESS_URL,
  CARRIER_INFO_URL,
  SET_QUOTE_URL,
  SO_TO_PO_DAVIS_URL,
  USPRIDE_IMPORT,
  ABCFF_IMPORT,
  USPRIDE_PRINT_SO_USPRIDE,
  PRINT_BOL_URL,
  USPRIDE_REPRINT_SO_USPRIDE,
  SO_PRINT_SALES_INVOICE_URL,
  COMPANY_URL,
  WAREHOUSE_BY_COMPANY_URL,
  INVENTORY_BATCH_URL,
  SEND_PACKING_LIST_URL,
  PROMOTIONS_URL,
} from './url';

import { ROOT_URL, ROOT_API_URL, isJML } from './root_url';

import { DEFAULT_ERROR } from '../components/Common/constants';
const isMAG = ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || ROOT_URL === 'https://magna-scm.truckxi.com/api/';

const isHMM = ROOT_URL === 'https://hmm-scm.truckxi.com/api/' || ROOT_API_URL === 'https://hmm-scm.truckxi.com/api/';
const isABC = ROOT_URL === 'https://abc-scm.truckxi.com/api/' || ROOT_API_URL === 'https://abc-scm.truckxi.com/api/';
const isDSQ = ROOT_API_URL === 'https://dsq-scm.truckxi.com/api/' || ROOT_URL === 'https://dsq-scm.truckxi.com/api/';
const isWIZ = ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
const isFJ = ROOT_API_URL === 'https://fj-scm.truckxi.com/api/' || ROOT_URL === 'https://fj-scm.truckxi.com/api/';
const isJTB = ROOT_API_URL === 'https://jtb-scm.truckxi.com/api/' || ROOT_URL === 'https://jtb-scm.truckxi.com/api/';
const isAFM =
  ROOT_API_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afmstage-scm.truckxi.com/api/";
const isKDW = ROOT_API_URL === 'https://kdw-scm.truckxi.com/api/' || ROOT_URL === 'https://kdw-scm.truckxi.com/api/';
const isABCFF = ROOT_API_URL === 'https://abcff-scm.truckxi.com/api/' || ROOT_URL === 'https://abcff-scm.truckxi.com/api/';
const isYI = ROOT_API_URL === 'https://ying-scm.truckxi.com/api/' || ROOT_URL === 'https://ying-scm.truckxi.com/api/';
const isFBD = ROOT_API_URL === 'https://fbd-scm.truckxi.com/api/' || ROOT_URL === 'https://fbd-scm.truckxi.com/api/';
const isWUFS = ROOT_API_URL === 'https://wufs-scm.truckxi.com/api/' || ROOT_URL === 'https://wufs-scm.truckxi.com/api/';
const isTN =
  ROOT_API_URL === "https://tn-scm.truckxi.com/api/" ||
  ROOT_URL === "https://tn-scm.truckxi.com/api/";

export function updateMSOFormInitialValues (data) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_CURRENT_SALES_ORDER_DETAIL_SHIPPINGINFO,
      payload: data,
    });
  };
};

export function fetchSalesOrders() {
  return (dispatch) => {
    dispatch(requestSalesOrders());
    return axios.get(
      SALES_ORDERS_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrdersSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesOrdersFailure(err));
      });
  };
}

export function requestSalesOrders() {
  return {
    type: REQUEST_SALES_ORDERS,
  };
}

export function fetchSalesOrdersSuccess(salesOrders) {
  return {
    type: FETCH_SALES_ORDERS_SUCCESS,
    payload: salesOrders,
  };
}

export function fetchSalesOrdersFailure(error) {
  return {
    type: FETCH_SALES_ORDERS_FAILURE,
    payload: error,
  };
}

export const generateSOWithExcelUSPride = (file, platform, customer, cb, ecb) => {
  let url = `${isABCFF ? ABCFF_IMPORT : USPRIDE_IMPORT}?platform=${platform}`;
  if (isABCFF) {
    url = `${ABCFF_IMPORT}?platform=${platform}&customer_id=${customer}`;
    // if (platform === 'other') {
    //   url = `${isABCFF ? ABCFF_IMPORT : USPRIDE_IMPORT}?platform=&customer_id=`
    // }
  }
  axios({
    method: 'post',
    url,
    data: file,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    cb && cb();
  }, (err) => {
    ecb && ecb();
    alert(err.data);
  })
}

export const expressMultipleSOInvoices = (pks, success, date) => {
  const url = `${ROOT_URL}v2/sales/multi_express_invoice/${pks.join(',')}`;
  let data = null;
  if (isTN) {
    data = {InvoiceShipDate: date};
  }
  axios({
    method: 'POST',
    url,
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    alert('success')
    success && success();
  }, (err) => {
    if (isMAG || isTN) {
      alert(err.data);
    } else {
      alert('failed');
    }
  });
}

export const QBAuthStatusCheck = (success, fails) => {
  const url = `${ROOT_URL}v1/quickbook/check_qb_authorization_status`;
  axios({
    method: 'GET',
    url,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    success();
  }, (err) => {
    fails();
  });  
}

export const getQBAuth = () => {
  const url = `${ROOT_URL}v1/quickbook/get_authorization`;
  axios({
    method: 'GET',
    url,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    const url = res.data;
    window.open(url, 'QB Auth...');
  }, (err) => {
    fails();
  }); 
}

export function fetchProductDetail(id, customer_id, company_id, warehouse_id, success) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PRODUCT_BY_ID });
    return axios.get(
      `${SALES_ORDER_PRODUCT_BY_ID_URL}${customer_id}/?Product_id=${id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        success(response.data);
      }, (err) => {
      });
  };
}

export const sendPacking = (data) => dispatch => {
  axios({
    method: 'get',
    url: `${SEND_PACKING_LIST_URL}${data}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then(res => {
    alert("Send packing list successfully");
  }, (err) => {
    alert('Error: Cannot send picking list.');
  })
}

export const printSalesOrderLabelUSPride = (data, cb) => dispatch => {
  dispatch({ type: REQUEST_SO_PDF });
  axios({
    method: 'post',
    url: isKDW ? `${PRINT_BOL_URL}${data}` : `${USPRIDE_PRINT_SO_USPRIDE}`,
    data: isKDW ? null : data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    responseType: 'blob',
  }).then(res => {
    dispatch(fetchSalesOrderPDFSuccess(res));
    cb && cb();
  }, (err) => {
    // alert(err.data);
    if (isKDW) {
      alert('Error: Cannot generate BOL pdf. Please check if order information is complete.');
    } else {
    alert('Error: Cannot generate new tracking numbers. Please check Shipstation settings.');
    }
    dispatch(fetchSalesOrderPDFSuccess([]));
  })
}

export const reprintSalesOrderLabelUSPride = (data, cb) => dispatch => {
  axios({
    method: 'post',
    url: `${USPRIDE_REPRINT_SO_USPRIDE}`,
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    responseType: 'blob',
  }).then(res => {
    dispatch(fetchSalesOrderPDFSuccess(res));
    cb && cb();
  }, (err) => {
    alert(err.data);
  })
}

export function fetchSalesOdersByDate(postingDateGT, postingDateLT, days) {
  const dates = toFromDates(days, postingDateGT, postingDateLT);
  return (dispatch) => {
    dispatch(requestSalesOrders());
    return axios.get(
      `${SALES_ORDERS_URL}search/?OrderDate__gte=${dates.fromDate
      }&OrderDate__lte=${dates.toDate}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrdersSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesOrdersFailure(err));
      });
  };
}

export function selectSalesOrder(salesOrder) {
  return {
    type: SELECT_SALES_ORDER,
    payload: salesOrder,
  };
}


export function resetCurrentSalesOrder() {
  return {
    type: RESET_CURRENT_SALES_ORDER,
  };
}

export function keepEstDate(date, route) {
  return (dispatch) => {
    dispatch(keepEstDateSuccess(date));
    browserHistory.push(route);
  };
}

export function keepEstDateSuccess(date) {
  return {
    type: KEEP_EST_DATE,
    payload: date,
  };
}

export function destroyEstDate() {
  return {
    type: DESTROY_EST_DATE,
  };
}

export function finishUnmount() {
  return {
    type: FINISHED_UNMOUNT,
  };
}

// Fetch the detail page.
export function fetchSalesOrderDetail(salesOrder_id, route) {
  const url = (route == 'salesOrders') ? SALES_ORDERS_URL : MOBILE_SALES_ORDERS_URL;
  return (dispatch) => {
    dispatch(requestSalesOrderDetail());
    return axios.get(
      `${url}?pk=${salesOrder_id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesOrderDetailFailure(err));
      });
  };
}

export function requestSalesOrderDetail() {
  return {
    type: REQUEST_SALES_ORDER_DETAIL,
  };
}


export function fetchSalesOrderDetailVIT(salesOrder_id, route) {
  const url =  VitAppointmentListOrders_URL;
  return (dispatch) => {
    dispatch(requestSalesOrderDetail());
    return axios.get(
      `${url}?pk=${salesOrder_id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderDetailIVTSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesOrderDetailFailure(err));
      });
  };
}

export function fetchSalesOrderDetailIVTSuccess(salesOrderDetail){
  orderDetail = salesOrderDetail.data;
  return {
    type: FETCH_SALES_ORDER_DETAIL_SUCCESS,
    payload: orderDetail,
  };
}


export function fetchSalesOrderDetailSuccess(salesOrderDetail) {
  salesOrderDetail = salesOrderDetail.data;
  // The date data fetched is in the form of string, which needs to be modified into Date type
  if (salesOrderDetail.OrderDate) salesOrderDetail.OrderDate = convertUtcDate(salesOrderDetail.OrderDate);
  if (salesOrderDetail.ETADate) salesOrderDetail.ETADate = convertUtcDate(salesOrderDetail.ETADate);
  if (salesOrderDetail.ReceivedDate) salesOrderDetail.ReceivedDate = convertUtcDate(salesOrderDetail.ReceivedDate);
  if (salesOrderDetail.DispatchDate) salesOrderDetail.DispatchDate = convertUtcDate(salesOrderDetail.DispatchDate);
  return {
    type: FETCH_SALES_ORDER_DETAIL_SUCCESS,
    payload: salesOrderDetail,
  };
}

export function fetchSalesOrderDetailFailure(error) {
  return {
    type: FETCH_SALES_ORDER_DETAIL_FAILURE,
    payload: error,
  };
}

export function requestSalesOrderDetailByNum() {
  return {
    type: REQUEST_SALES_ORDER_DETAIL_BY_NUM,
  };
}

export function fetchSalesOrderDetailByNumSuccess(salesOrderDetail) {
  return {
    type: FETCH_SALES_ORDER_DETAIL_BY_NUM_SUCCESS,
    payload: salesOrderDetail.data,
  };
}

export function fetchSalesOrderDetailByNumFailure(error) {
  return {
    type: FETCH_SALES_ORDER_DETAIL_BY_NUM_FAILURE,
    payload: error,
  };
}


export function fetchSalesOrderDetailByNum(SONum) {
  return (dispatch) => {
    dispatch(requestSalesOrderDetailByNum());
    return axios.get(
      `${SALES_ORDERS_URL}?SONum=${SONum}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderDetailByNumSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesOrderDetailByNumFailure(err));
      });
  };
}
export function createSalesQuote({
  Sales_Order_Lines,
  Deliver_CustomerDetail_id,
  Deliver_Customer_id,
  IsWholesale,
  PaymentTerm_id,
  Agent_id,
  Pickup_Warehouse_id,
  OrderDate,
  ETADate,
  DispatchDate,
  CPONum, 
  TrackingNum,
  // dsq
  OrderType,
  IsDevan,
  IsDrayage,
  ContainerNum, 
  // kdw
  SSL,
  MBL,
  Pin,
  ChassisType,
  PierPass,
  LastFreeDay,
  IsFBAAddress,
  DestinationAddress,
  ISANum,
  Trucker,
  ReleaseDate,
  ReadyDate,
  OutboundDate,
  ShipmentID,
  Destination,
  ContainerSize,
  SalesOrderTypeSy,
  ISANote,
  DLNum,
  Carrier,
  Port,
  LFDate,
  IsDO,
  IsDirectShip,
  IsBOL,
  IsSeal,
  BOL,
  POD,
  IsPOD,
  FBARoute,
  ReceiveType,
  ReceiveUnit,
  DropshipType,
  Appointment,
  AppointmentDate,
  ShipmentDate,
  Warehouse_id,
  TruckingCo,
  DeliverTo,
  IsReturnEmpty,
  ArrivalDate,
  ReturnDate,
  StorageInDate,
  StorageOutDate,
  // dsq
  ExtInvoiceNum,
  Broker,
  Truckload,
  TruckNum,
  Dispatch,
  DetentionRate,
  LumperFee,
  PalletSpace,
  PickupDriver,
  PickupTrailerNum,
  PickupDate,
  PickupTime,
  PickupStreet,
  PickupZip,
  PickupCity,
  PickupState,
  PickupAppt,
  DropoffDriver,
  DropoffTrailerNum,
  DropoffDate,
  DropoffTime,
  DropoffStreet,
  DropoffZip,
  DropoffCity,
  DropoffState,
  DropoffAppt,
  // fj
  IsOutbound,
  RefNum, 
  Type, 
  ClientCustName,
  ShipByDate,
  DocumentDate,
  UpdateTime,
  FinalNetWeight,
  FinalShippingWeight,
  TotalPrice,
  FinalWeight,
  CarryType,
  Discount,
  Savings,
  ShippingCost,
  HandlingCost,
  SalesStatus,
  MiscCost,
  MiscNote,
  TaxAmount,
  TaxRate,
  FinalPrice,
  ConvertItemPrice,
  Deliver_Warehouse_id,
  DispatchMethod_id,
  DispatchOutSourceContact_id,
  Sales_User_id,
  Product_id,
  Modifier_User_id,
  Notation,
  EmployeeNote,
  RouteNote,
  Note,
  TotalCRV,
  RefPrice,
  IsNoReduce,
  TrailerNum,
  Trailer,
  DSQID,

  // kdw
  PickupApptDate,
DeliveryApptDate,
DeliveryDate,
PerdiemDate,
Yard,
PortWaitTime,
ReturnTo,
EmptyReadyDate,
DrayageCity,

  //mag
SaleStatus,
delivery_address,
delivery_eta,
delivery_lfd,
DeliveryStatus,
cntrLocation,
mag_note_other,
DeliveryStatusOther,
contact_person,
contact_email,
  cntrNum,
  bolNum,
  shipping_line,
  size,
  cargo_weight,
  terminal,
  mag_note,
  OrderPalletQty,
  LooseQty,
  // cnt
  ShippingMethod,
  // fung, fv
  PONum,
  //TQ
  Company_id,
}) {
  if (Company_id && Company_id.value) {
    Company_id = Company_id.value;
  }
  if (PaymentTerm_id && PaymentTerm_id.value) {
    PaymentTerm_id = PaymentTerm_id.value;
  }
  if (Agent_id && Agent_id.value) {
    Agent_id = Agent_id.value;
  }
  if (Warehouse_id && Warehouse_id.value) {
    Warehouse_id = Warehouse_id.value;
  }
  if (isFJ && Carrier && Carrier.value) {
    Carrier = Carrier.value;
  }
  if (DestinationAddress && DestinationAddress.value) {
    DestinationAddress = DestinationAddress.value;
  }
  if (PickupState && PickupState.value) {
    PickupState = PickupState.value;
  }
  if (DropoffState && DropoffState.value) {
    DropoffState = DropoffState.value;
  }
  if (ContainerSize && ContainerSize.value) {
    ContainerSize = ContainerSize.value;
  }
  if (SalesOrderTypeSy && SalesOrderTypeSy.value) {
    SalesOrderTypeSy = SalesOrderTypeSy.value;
  }
  if (ReceiveType && ReceiveType.value) {
    ReceiveType = ReceiveType.value;
  }
  if (ReceiveUnit && ReceiveUnit.value) {
    ReceiveUnit = ReceiveUnit.value;
  }
  if ((isJTB) && OrderType && OrderType.value) {
    OrderType = OrderType.value;
  }
  
  // let Devan = true;
  // let Drayage = true;
  // if (isKDW) {
  //   if (OrderType === 'DrayageOnly') {
  //     Devan = false;
  //     Drayage = true;
  //   }
  //   if (OrderType === 'DevanningOnly') {
  //     Devan = true;
  //     Drayage = false;
  //   }
  //   if (OrderType === 'DrayageAndDevanning') {
  //     Devan = true;
  //     Drayage = true;
  //   }
  // }

  if ((isMAG || isKDW) && SaleStatus && SaleStatus.value) {
    SaleStatus = SaleStatus.value;
  }
  if ((isMAG || isKDW) && shipping_line && shipping_line.value) {
    shipping_line = shipping_line.value;
  }
  if ((isMAG || isKDW) && terminal && terminal.value) {
    terminal = terminal.value;
  }
  if ((isMAG || isKDW) && mag_note && mag_note.value) {
    mag_note = mag_note.value;
  }
  if ((isMAG || isKDW) && size && size.value) {
    size = size.value;
  }
  if (DropshipType && DropshipType.value) {
    DropshipType = DropshipType.value;
  }
  if (!UpdateTime) UpdateTime = convertUtcDate();
  if (Deliver_Customer_id) Deliver_Customer_id = Deliver_Customer_id.value || Deliver_Customer_id;
  if(isHMM) {
    Sales_Order_Lines = Sales_Order_Lines.map( line => {
      return {
        ...line,
        TotalPrice: line.Quantity * line.UnitPrice * line.PackageSize_1
      }
    })
  }

  let dsqWT = false;
  if (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD) {
    Sales_Order_Lines.map( (line,i) => {
      // if ((!line.Quantity || line.Quantity === 0 || line.Quantity === '0') && (!line.PalletQuantity || line.PalletQuantity === 0 || line.PalletQuantity === '0')) {
      //   alert("Please enter either Box or Pallet quantity for each line.");
      //   dsqWT = true;
      // }
      // if (line.PalletQuantity && (Number(line.PalletQuantity) > 0)) {
      //   if (line.Quantity && (Number(line.Quantity) > 0)) {
      //     alert("A single product line cannot contain both Box and Pallet quantities.");
      //     dsqWT = true;
      //   }
      // }
      if (line.PalletQuantity && (Number(line.PalletQuantity) > 0)) {
        if (!line.Quantity || line.Quantity === 0 || line.Quantity === '0') {
          Sales_Order_Lines[i].Quantity = "1";
        }
      }
    });
    if (dsqWT) {
      return;
    }
  }

  if ((isMAG || isKDW)) {
    Sales_Order_Lines = [
      {
        "ProductTax": 0,
        "CRV": 0,
        "Product_id": 1,
        "SalesOrderLine_id": 27,
        "ImageUrl": null,
        "RefPrice": 600,
        "RefNum": "",
        "TotalNetWeight": 1,
        "ProductType": "Fixed",
        "TotalShippingWeight": 0,
        "MeasureUnit": "LB",
        "TotalPrice": 600,
        "NetWeight": 1,
        "Description": "服务费",
        "PackageSize": "1case*1case",
        "PackageSize_1": "1",
        "IsTaxable": false,
        "Remark": null,
        "ProductDescription": "服务费",
        "Name": "service fee",
        "ProductNum": "01010001",
        "PackageType": "case",
        "Product_id_id": 1,
        "PickupQuantity": 0,
        "CostPrice": 0,
        "IsMobileLine": null,
        "Order": 1,
        "Quantity": 1,
        "IsForFree": false,
        "ProductName": "service fee",
        "SalesOrder_id_id": 27,
        "LoadedQuantity": 0,
        "Weights": null,
        "Batch_PONum": null,
        "UnitPrice": 600
      }
    ];
  }

  return (dispatch) => {
    dispatch({ type: REQUEST_CREATING_SALES_ORDER });
    axios.post(
      `${SALES_QUOTE_URL}`,
      {
        Sales_Order_Lines,
        Deliver_CustomerDetail_id,
        Deliver_Customer_id,
        IsWholesale,
        PaymentTerm_id,
        Agent_id,
        Pickup_Warehouse_id,
        OrderDate,
        ETADate,
        DispatchDate,
        CPONum, 
        TrackingNum,
        // dsq
        OrderType,
        IsDevan,
        IsDrayage,
        ContainerNum, 
        SSL,
  MBL,
  Pin,
  ChassisType,
  PierPass,
  LastFreeDay,
        IsFBAAddress,
        DestinationAddress,
        ISANum,
        Trucker,
        ReleaseDate,
        ReadyDate,
        OutboundDate,
        ShipmentID,
        Destination,
        ContainerSize,
        SalesOrderTypeSy,
        ISANote,
        DLNum,
        Carrier,
        Port,
        LFDate,
        IsDO,
        IsDirectShip,
        IsBOL,
        IsSeal,
        BOL,
        POD,
        IsPOD,
        FBARoute,
        ReceiveType,
        ReceiveUnit,
        DropshipType,
        Appointment,
        AppointmentDate,
        ShipmentDate,
        Warehouse_id,
        TruckingCo,
        DeliverTo,
        IsReturnEmpty,
        ArrivalDate,
        ReturnDate,
        StorageInDate,
        StorageOutDate,
        // dsq
        ExtInvoiceNum,
        Broker,
        Truckload,
        TruckNum,
        Dispatch,
        DetentionRate,
        LumperFee,
        PalletSpace,
        PickupDriver,
        PickupTrailerNum,
        PickupDate,
        PickupTime,
        PickupStreet,
        PickupZip,
        PickupCity,
        PickupState,
        PickupAppt,
        DropoffDriver,
        DropoffTrailerNum,
        DropoffDate,
        DropoffTime,
        DropoffStreet,
        DropoffZip,
        DropoffCity,
        DropoffState,
        DropoffAppt,
        // 
        IsOutbound,
        RefNum, 
        Type, 
        ClientCustName,
        ShipByDate,
        DocumentDate,
        UpdateTime,
        FinalNetWeight,
        FinalShippingWeight,
        TotalPrice,
        FinalWeight,
        CarryType,
        Discount,
        Savings,
        ShippingCost,
        HandlingCost,
        MiscCost,
        MiscNote,
        TaxAmount,
        TaxRate,
        SalesStatus,
        FinalPrice,
        ConvertItemPrice,
        Deliver_Warehouse_id,
        DispatchMethod_id,
        DispatchOutSourceContact_id,
        Sales_User_id,
        Product_id,
        Modifier_User_id,
        Notation,
        EmployeeNote,
        RouteNote,
        Note,
        TotalCRV,
        RefPrice,
        IsNoReduce,
        TrailerNum,
        // kdw
  PickupApptDate,
  DeliveryApptDate,
  DeliveryDate,
  PerdiemDate,
  Yard,
  PortWaitTime,
  ReturnTo,
  EmptyReadyDate,
  DrayageCity,

        Trailer,
        DSQID,
        cntrNum,

  //mag
SaleStatus,
delivery_address,
delivery_eta,
delivery_lfd,
DeliveryStatus,
cntrLocation,
mag_note_other,
DeliveryStatusOther,
contact_person,
contact_email,
        bolNum,
        shipping_line,
        size,
        cargo_weight,
        terminal,
        mag_note,
        OrderPalletQty,
        LooseQty,
        // cnt
        ShippingMethod,
        // fung, fv
        PONum,
        //TQ
        Company_id,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(createSalesOrderSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(createSalesOrderFailure(err));
      });
  };
}

export function createSalesOrder({
  Sales_Order_Lines,
  Deliver_CustomerDetail_id,
  Deliver_Customer_id,
  IsWholesale,
  PaymentTerm_id,
  Agent_id,
  Pickup_Warehouse_id,
  OrderDate,
  ETADate,
  DispatchDate,
  DispatchStartTime,
  DispatchEndTime,
  CPONum, 
  TrackingNum,
  // dsq
  OrderType,
  IsDevan,
  IsDrayage,
  ContainerNum, 
  SSL,
  MBL,
  Pin,
  ChassisType,
  PierPass,
  LastFreeDay,
  IsFBAAddress,
  DestinationAddress,
  ISANum,
  Trucker,
  ReleaseDate,
  ReadyDate,
  OutboundDate,
  ShipmentID,
  Destination,
  ContainerSize,
  SalesOrderTypeSy,
  ISANote,
  DLNum,
  Carrier,
  Port,
  LFDate,
  IsDO,
  IsDirectShip,
  IsBOL,
  IsSeal,
  BOL,
  POD,
  IsPOD,
  FBARoute,
  ReceiveType,
  ReceiveUnit,
  DropshipType,
  Appointment,
  AppointmentDate,
  ShipmentDate,
  Warehouse_id,
  TruckingCo,
  DeliverTo,
  IsReturnEmpty,
  ArrivalDate,
  ReturnDate,
  StorageInDate,
  StorageOutDate,
  // dsq
  ExtInvoiceNum,
  Broker,
  Truckload,
  TruckNum,
  Dispatch,
  DetentionRate,
  LumperFee,
  PalletSpace,
  PickupDriver,
  PickupTrailerNum,
  PickupDate,
  PickupTime,
  PickupStreet,
  PickupZip,
  PickupCity,
  PickupState,
  PickupAppt,
  DropoffDriver,
  DropoffTrailerNum,
  DropoffDate,
  DropoffTime,
  DropoffStreet,
  DropoffZip,
  DropoffCity,
  DropoffState,
  DropoffAppt,
  // fj
  IsOutbound,
  RefNum, 
  Type, 
  ClientCustName,
  ShipByDate,
  DocumentDate,
  UpdateTime,
  FinalNetWeight,
  FinalShippingWeight,
  TotalPrice,
  FinalWeight,
  CarryType,
  Discount,
  Savings,
  ShippingCost,
  HandlingCost,
  SalesStatus,
  MiscCost,
  MiscNote,
  TaxAmount,
  TaxRate,
  FinalPrice,
  ConvertItemPrice,
  Deliver_Warehouse_id,
  DispatchMethod_id,
  DispatchOutSourceContact_id,
  Sales_User_id,
  Product_id,
  Modifier_User_id,
  Notation,
  EmployeeNote,
  RouteNote,
  Note,
  TotalCRV,
  RefPrice,
  IsNoReduce,
  TrailerNum,
  // kdw
  PickupApptDate,
DeliveryApptDate,
DeliveryDate,
PerdiemDate,
Yard,
PortWaitTime,
ReturnTo,
EmptyReadyDate,
DrayageCity,

  Trailer,
  DSQID,

  //mag
  SaleStatus,
  delivery_address,
  delivery_eta,
  delivery_lfd,
  DeliveryStatus,
  cntrLocation,
  mag_note_other,
  DeliveryStatusOther,
  contact_person,
  contact_email,
  cntrNum,
  
  bolNum,
  shipping_line,
  size,
  cargo_weight,
  terminal,
  mag_note,
  OrderPalletQty,
  LooseQty,
  // cnt
  ShippingMethod,
  // fung, fv
  PONum,
  //TQ
  Company_id,
}) {
  if (Company_id && Company_id.value) {
    Company_id = Company_id.value;
  }
  if (PaymentTerm_id && PaymentTerm_id.value) {
    PaymentTerm_id = PaymentTerm_id.value;
  }
  if (Agent_id && Agent_id.value) {
    Agent_id = Agent_id.value;
  }
  if (Warehouse_id && Warehouse_id.value) {
    Warehouse_id = Warehouse_id.value;
  }
  if (isFJ && Carrier && Carrier.value) {
    Carrier = Carrier.value;
  }
  if (DestinationAddress && DestinationAddress.value) {
    DestinationAddress = DestinationAddress.value;
  }
  if (PickupState && PickupState.value) {
    PickupState = PickupState.value;
  }
  if (DropoffState && DropoffState.value) {
    DropoffState = DropoffState.value;
  }
  if (ContainerSize && ContainerSize.value) {
    ContainerSize = ContainerSize.value;
  }
  if (SalesOrderTypeSy && SalesOrderTypeSy.value) {
    SalesOrderTypeSy = SalesOrderTypeSy.value;
  }
  if (ReceiveType && ReceiveType.value) {
    ReceiveType = ReceiveType.value;
  }
  if (ReceiveUnit && ReceiveUnit.value) {
    ReceiveUnit = ReceiveUnit.value;
  }
  if ((isJTB) && OrderType && OrderType.value) {
    OrderType = OrderType.value;
  }
  // let Devan = true;
  // let Drayage = true;
  // if (isKDW) {
  //   if (OrderType === 'DrayageOnly') {
  //     Devan = false;
  //     Drayage = true;
  //   }
  //   if (OrderType === 'DevanningOnly') {
  //     Devan = true;
  //     Drayage = false;
  //   }
  //   if (OrderType === 'DrayageAndDevanning') {
  //     Devan = true;
  //     Drayage = true;
  //   }
  // }

  if ((isMAG || isKDW) && SaleStatus && SaleStatus.value) {
    SaleStatus = SaleStatus.value;
  }
  if ((isMAG || isKDW) && shipping_line && shipping_line.value) {
    shipping_line = shipping_line.value;
  }
  if ((isMAG || isKDW) && terminal && terminal.value) {
    terminal = terminal.value;
  }
  if ((isMAG || isKDW) && mag_note && mag_note.value) {
    mag_note = mag_note.value;
  }
  if ((isMAG || isKDW) && size && size.value) {
    size = size.value;
  }
  if (DropshipType && DropshipType.value) {
    DropshipType = DropshipType.value;
  }
  if (!UpdateTime) UpdateTime = convertUtcDate();
  if (Deliver_Customer_id) Deliver_Customer_id = Deliver_Customer_id.value || Deliver_Customer_id;
  if(isHMM) {
    Sales_Order_Lines = Sales_Order_Lines.map( line => {
      return {
        ...line,
        TotalPrice: line.Quantity * line.UnitPrice * line.PackageSize_1
      }
    })
  }

  let dsqWT = false;
  if (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD) {
    Sales_Order_Lines.map( (line,i) => {
      // if ((!line.Quantity || line.Quantity === 0 || line.Quantity === '0') && (!line.PalletQuantity || line.PalletQuantity === 0 || line.PalletQuantity === '0')) {
      //   alert("Please enter either Box or Pallet quantity for each line.");
      //   dsqWT = true;
      // }
      // if (line.PalletQuantity && (Number(line.PalletQuantity) > 0)) {
      //   if (line.Quantity && (Number(line.Quantity) > 0)) {
      //     alert("A single product line cannot contain both Box and Pallet quantities.");
      //     dsqWT = true;
      //   }
      // }
      if (line.PalletQuantity && (Number(line.PalletQuantity) > 0)) {
        if (!line.Quantity || line.Quantity === 0 || line.Quantity === '0') {
          Sales_Order_Lines[i].Quantity = "1";
        }
      }
    });
    if (dsqWT) {
      return;
    }
  }

  if ((isMAG || isKDW)) {
    Sales_Order_Lines = [
      {
        "ProductTax": 0,
        "CRV": 0,
        "Product_id": 1,
        "SalesOrderLine_id": 27,
        "ImageUrl": null,
        "RefPrice": 600,
        "RefNum": "",
        "TotalNetWeight": 1,
        "ProductType": "Fixed",
        "TotalShippingWeight": 0,
        "MeasureUnit": "LB",
        "TotalPrice": 600,
        "NetWeight": 1,
        "Description": "服务费",
        "PackageSize": "1case*1case",
        "PackageSize_1": "1",
        "IsTaxable": false,
        "Remark": null,
        "ProductDescription": "服务费",
        "Name": "service fee",
        "ProductNum": "01010001",
        "PackageType": "case",
        "Product_id_id": 1,
        "PickupQuantity": 0,
        "CostPrice": 0,
        "IsMobileLine": null,
        "Order": 1,
        "Quantity": 1,
        "IsForFree": false,
        "ProductName": "service fee",
        "SalesOrder_id_id": 27,
        "LoadedQuantity": 0,
        "Weights": null,
        "Batch_PONum": null,
        "UnitPrice": 600
      }
    ];
  }

  return (dispatch) => {
    dispatch({ type: REQUEST_CREATING_SALES_ORDER });
    axios.post(
      SALES_ORDERS_URL,
      {
        Sales_Order_Lines,
        Deliver_CustomerDetail_id,
        Deliver_Customer_id,
        IsWholesale,
        PaymentTerm_id,
        Agent_id,
        Pickup_Warehouse_id,
        OrderDate,
        ETADate,
        DispatchDate,
        DispatchStartTime,
        DispatchEndTime,
        CPONum,
        TrackingNum, 
        // dsq
        OrderType,
        IsDevan,
        IsDrayage,
        ContainerNum, 
        SSL,
  MBL,
  Pin,
  ChassisType,
  PierPass,
  LastFreeDay,
        IsFBAAddress,
        DestinationAddress,
        ISANum,
        Trucker,
        ReleaseDate,
        ReadyDate,
        OutboundDate,
        ShipmentID,
        Destination,
        ContainerSize,
        SalesOrderTypeSy,
        ISANote,
        DLNum,
        Carrier,
        Port,
        LFDate,
        IsDO,
        IsDirectShip,
        IsBOL,
        IsSeal,
        BOL,
        POD,
        IsPOD,
        FBARoute,
        ReceiveType,
        ReceiveUnit,
        DropshipType,
        Appointment,
        AppointmentDate,
        ShipmentDate,
        Warehouse_id,
        TruckingCo,
        DeliverTo,
        IsReturnEmpty,
        ArrivalDate,
        ReturnDate,
        StorageInDate,
        StorageOutDate,
        // dsq
        ExtInvoiceNum,
        Broker,
        Truckload,
        TruckNum,
        Dispatch,
        DetentionRate,
        LumperFee,
        PalletSpace,
        PickupDriver,
        PickupTrailerNum,
        PickupDate,
        PickupTime,
        PickupStreet,
        PickupZip,
        PickupCity,
        PickupState,
        PickupAppt,
        DropoffDriver,
        DropoffTrailerNum,
        DropoffDate,
        DropoffTime,
        DropoffStreet,
        DropoffZip,
        DropoffCity,
        DropoffState,
        DropoffAppt,
        // 
        IsOutbound,
        RefNum, 
        Type, 
        ClientCustName,
        ShipByDate,
        DocumentDate,
        UpdateTime,
        FinalNetWeight,
        FinalShippingWeight,
        TotalPrice,
        FinalWeight,
        CarryType,
        Discount,
        Savings,
        ShippingCost,
        HandlingCost,
        MiscCost,
        MiscNote,
        TaxAmount,
        TaxRate,
        SalesStatus,
        FinalPrice,
        ConvertItemPrice,
        Deliver_Warehouse_id,
        DispatchMethod_id,
        DispatchOutSourceContact_id,
        Sales_User_id,
        Product_id,
        Modifier_User_id,
        Notation,
        EmployeeNote,
        RouteNote,
        Note,
        TotalCRV,
        RefPrice,
        IsNoReduce,
        TrailerNum,
        // kdw
  PickupApptDate,
  DeliveryApptDate,
  DeliveryDate,
  PerdiemDate,
  Yard,
  PortWaitTime,
  ReturnTo,
  EmptyReadyDate,
  DrayageCity,

        Trailer,
        DSQID,
        cntrNum,

  //mag
SaleStatus,
delivery_address,
delivery_eta,
delivery_lfd,
DeliveryStatus,
cntrLocation,
mag_note_other,
DeliveryStatusOther,
contact_person,
contact_email,
        bolNum,
        shipping_line,
        size,
        cargo_weight,
        terminal,
        mag_note,
        OrderPalletQty,
        LooseQty,
        // cnt
        ShippingMethod,
        // fung, fv
        PONum,
        //TQ
        Company_id,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(createSalesOrderSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(createSalesOrderFailure(err));
      });
  };
}

export function createSalesOrderSuccess(order) {
  return {
    type: CREATE_SALES_ORDER_SUCCESS,
    payload: order,
  };
}

export function createSalesOrderFailure(error) {
  return {
    type: CREATE_SALES_ORDER_FAILURE,
    payload: error,
  };
}

export function editSalesOrder({
  Sales_Order_Lines,
  SONum,
  Deliver_CustomerDetail_id,
  Deliver_Customer_id,
  Delivery,
  IsWholesale,
  PaymentTerm_id,
  Agent_id,
  Pickup_Warehouse_id,
  OrderDate,
  ETADate,
  DispatchDate,
  DispatchStartTime,
  DispatchEndTime,
  CPONum, 
  TrackingNum,
  // dsq
  OrderType,
  IsDevan,
  IsDrayage,
  ContainerNum, 
  SSL,
  MBL,
  Pin,
  ChassisType,
  PierPass,
  LastFreeDay,
  IsFBAAddress,
  DestinationAddress,
  ISANum,
  Trucker,
  ReleaseDate,
  ReadyDate,
  OutboundDate,
  ShipmentID,
  Destination,
  ContainerSize,
  SalesOrderTypeSy,
  ISANote,
  DLNum,
  Carrier,
  Port,
  LFDate,
  IsDO,
  IsDirectShip,
  IsBOL,
  IsSeal,
  BOL,
  POD,
  IsPOD,
  FBARoute,
  ReceiveType,
  ReceiveUnit,
  DropshipType,
  Appointment,
  AppointmentDate,
  ShipmentDate,
  Warehouse_id,
  TruckingCo,
  DeliverTo,
  IsReturnEmpty,
  ArrivalDate,
  ReturnDate,
  StorageInDate,
  StorageOutDate,
  // dsq
  ExtInvoiceNum,
  Broker,
  Truckload,
  TruckNum,
  Dispatch,
  DetentionRate,
  LumperFee,
  PalletSpace,
  PickupDriver,
  PickupTrailerNum,
  PickupDate,
  PickupTime,
  PickupStreet,
  PickupZip,
  PickupCity,
  PickupState,
  PickupAppt,
  DropoffDriver,
  DropoffTrailerNum,
  DropoffDate,
  DropoffTime,
  DropoffStreet,
  DropoffZip,
  DropoffCity,
  DropoffState,
  DropoffAppt,
  // fj
  IsOutbound,
  RefNum, 
  Type, 
  ClientCustName,
  ShipByDate,
  FinalNetWeight,
  TrailerNum,
  // kdw
  PickupApptDate,
DeliveryApptDate,
DeliveryDate,
PerdiemDate,
Yard,
PortWaitTime,
ReturnTo,
EmptyReadyDate,
DrayageCity,

  Trailer,
  DSQID,
  cntrNum,

  //mag
SaleStatus,
delivery_address,
delivery_eta,
delivery_lfd,
DeliveryStatus,
cntrLocation,
mag_note_other,
DeliveryStatusOther,
contact_person,
contact_email,
  bolNum,
  shipping_line,
  size,
  cargo_weight,
  terminal,
  mag_note,
  OrderPalletQty,
  LooseQty,
  // FinalShippingWeight,
  TotalCRV,
  TotalPrice,
  FinalWeight,
  CarryType,
  Discount,
  Savings,
  ShippingCost,
  HandlingCost,
  SalesStatus,
  MiscCost,
  MiscNote,
  TaxAmount,
  TaxRate,
  FinalPrice,
  ConvertItemPrice,
  Deliver_Warehouse_id,
  DispatchMethod_id,
  DispatchOutSourceContact_id,
  Sales_User_id,
  Product_id,
  Modifier_User_id,
  Notation,
  // EmployeeNote,
  RouteNote,
  Note,
  RefPrice,
  IsNoReduce,
  Notes,
  // fung, fv
  PONum,
  //TQ
  Company_id,
}, SalesOrder_id) {
  if (Company_id && Company_id.value) {
    Company_id = Company_id.value;
  }
  if (PaymentTerm_id && PaymentTerm_id.value) {
    PaymentTerm_id = PaymentTerm_id.value;
  }
  if (isFJ && Carrier && Carrier.value) {
    Carrier = Carrier.value;
  }
  if (Agent_id && Agent_id.value) {
    Agent_id = Agent_id.value;
  }
  if (Warehouse_id && Warehouse_id.value) {
    Warehouse_id = Warehouse_id.value;
  }
  if (DestinationAddress && DestinationAddress.value) {
    DestinationAddress = DestinationAddress.value;
  }
  if (PickupState && PickupState.value) {
    PickupState = PickupState.value;
  }
  if (DropoffState && DropoffState.value) {
    DropoffState = DropoffState.value;
  }
  if (ContainerSize && ContainerSize.value) {
    ContainerSize = ContainerSize.value;
  }
  if (SalesOrderTypeSy && SalesOrderTypeSy.value) {
    SalesOrderTypeSy = SalesOrderTypeSy.value;
  }
  if (ReceiveType && ReceiveType.value) {
    ReceiveType = ReceiveType.value;
  }
  if (ReceiveUnit && ReceiveUnit.value) {
    ReceiveUnit = ReceiveUnit.value;
  }
  if ((isJTB) && OrderType && OrderType.value) {
    OrderType = OrderType.value;
  }
  // let Devan = true;
  // let Drayage = true;
  // if (isKDW) {
  //   if (OrderType === 'DrayageOnly') {
  //     Devan = false;
  //     Drayage = true;
  //   }
  //   if (OrderType === 'DevanningOnly') {
  //     Devan = true;
  //     Drayage = false;
  //   }
  //   if (OrderType === 'DrayageAndDevanning') {
  //     Devan = true;
  //     Drayage = true;
  //   }
  // }

  if ((isMAG || isKDW) && SaleStatus && SaleStatus.value) {
    SaleStatus = SaleStatus.value;
  }
  if ((isMAG || isKDW) && shipping_line && shipping_line.value) {
    shipping_line = shipping_line.value;
  }
  if ((isMAG || isKDW) && terminal && terminal.value) {
    terminal = terminal.value;
  }
  if ((isMAG || isKDW) && mag_note && mag_note.value) {
    mag_note = mag_note.value;
  }
  if ((isMAG || isKDW) && size && size.value) {
    size = size.value;
  }



  let dsqWT = false;
  if (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD) {
    Sales_Order_Lines.map( (line,i) => {
      // if ((!line.Quantity || line.Quantity === 0 || line.Quantity === '0') && (!line.PalletQuantity || line.PalletQuantity === 0 || line.PalletQuantity === '0')) {
      //   alert("Please enter either Box or Pallet quantity for each line.");
      //   dsqWT = true;
      // }
      // if (line.PalletQuantity && (Number(line.PalletQuantity) > 0)) {
      //   if (line.Quantity && (Number(line.Quantity) > 0)) {
      //     alert("A single product line cannot contain both Box and Pallet quantities.");
      //     dsqWT = true;
      //   }
      // }
      if (line.PalletQuantity && (Number(line.PalletQuantity) > 0)) {
        if (!line.Quantity || line.Quantity === 0 || line.Quantity === '0') {
          Sales_Order_Lines[i].Quantity = "1";
        }
      }
    });
    if (dsqWT) {
      return;
    }
  }
  if (DropshipType && DropshipType.value) {
    DropshipType = DropshipType.value;
  }
  if (!OrderDate) OrderDate = convertUtcDate();
  if (Deliver_Customer_id) Deliver_Customer_id = Deliver_Customer_id.value || Deliver_Customer_id;
  return (dispatch) => {
    dispatch({ type: REQUEST_EDITING_SALES_ORDER });
    axios.put(
      (SALES_ORDERS_URL + SalesOrder_id),
      {
        Sales_Order_Lines,
        SONum,
        Deliver_CustomerDetail_id,
        Deliver_Customer_id,
        Delivery,
        IsWholesale,
        PaymentTerm_id,
        Agent_id,
        Pickup_Warehouse_id,
        OrderDate,
        ETADate,
        DispatchDate,
        DispatchStartTime,
        DispatchEndTime,
        CPONum, 
        TrackingNum,
        // dsq
        OrderType,
        IsDevan,
        IsDrayage,
        ContainerNum, 
        SSL,
  MBL,
  Pin,
  ChassisType,
  PierPass,
  LastFreeDay,
        IsFBAAddress,
        DestinationAddress,
        ISANum,
        Trucker,
        ReleaseDate,
        ReadyDate,
        OutboundDate,
        ShipmentID,
        Destination,
        ContainerSize,
        SalesOrderTypeSy,
        ISANote,
        DLNum,
        Carrier,
        Port,
        LFDate,
        IsDO,
        IsDirectShip,
        IsBOL,
        IsSeal,
        BOL,
        POD,
        IsPOD,
        FBARoute,
        ReceiveType,
        ReceiveUnit,
        DropshipType,
        Appointment,
        AppointmentDate,
        ShipmentDate,
        Warehouse_id,
        TruckingCo,
        DeliverTo,
        IsReturnEmpty,
        ArrivalDate,
        ReturnDate,
        StorageInDate,
        StorageOutDate,
        // 
        ExtInvoiceNum,
        Broker,
        Truckload,
        TruckNum,
        Dispatch,
        DetentionRate,
        LumperFee,
        PalletSpace,
        PickupDriver,
        PickupTrailerNum,
        PickupDate,
        PickupTime,
        PickupStreet,
        PickupZip,
        PickupCity,
        PickupState,
        PickupAppt,
        DropoffDriver,
        DropoffTrailerNum,
        DropoffDate,
        DropoffTime,
        DropoffStreet,
        DropoffZip,
        DropoffCity,
        DropoffState,
        DropoffAppt,
        // 
        IsOutbound,
        TrailerNum,
        // kdw
  PickupApptDate,
  DeliveryApptDate,
  DeliveryDate,
  PerdiemDate,
  Yard,
  PortWaitTime,
  ReturnTo,
  EmptyReadyDate,
  DrayageCity,
  
        Trailer,
        DSQID,
        cntrNum,

  //mag
SaleStatus,
delivery_address,
delivery_eta,
delivery_lfd,
DeliveryStatus,
cntrLocation,
mag_note_other,
DeliveryStatusOther,
contact_person,
contact_email,
        bolNum,
        shipping_line,
        size,
        cargo_weight,
        terminal,
        mag_note,
        OrderPalletQty,
        LooseQty,
        // dsq
        RefNum, 
        Type, 
        ClientCustName,
        ShipByDate,
        FinalNetWeight,
        // FinalShippingWeight,
        TotalCRV,
        TotalPrice,
        FinalWeight,
        CarryType,
        Discount,
        Savings,
        ShippingCost,
        HandlingCost,
        SalesStatus,
        MiscCost,
        MiscNote,
        TaxAmount,
        TaxRate,
        FinalPrice,
        ConvertItemPrice,
        Deliver_Warehouse_id,
        DispatchMethod_id,
        DispatchOutSourceContact_id,
        Sales_User_id,
        Product_id,
        Modifier_User_id,
        Notation,
        // EmployeeNote,
        RouteNote,
        Note,
        RefPrice,
        IsNoReduce,
        Notes,
        // fung, fv
        PONum,
        //TQ
        Company_id,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(editSalesOrderSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(editSalesOrderFailure(err));
      });
  };
}

export function editSalesOrderSuccess(order) {
  return {
    type: EDIT_SALES_ORDER_SUCCESS,
    payload: order,
  };
}

export function editSalesOrderFailure(error) {
  return {
    type: EDIT_SALES_ORDER_FAILURE,
    payload: error,
  };
}

export const setOrderToOpen = (soid, success) => dispatch => {
  axios({
    method: 'PUT',
    url: `${ROOT_URL}v1/sale/reopen/${soid}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
  .then(res => {
    success()
  })
  .catch(err => {
    alert('ERROR');
  })
}

export function voidSalesOrder(salesOrder_id, route = '') {
  return (dispatch) => {
    dispatch({ type: REQUEST_VOID_SALES_ORDER });
    axios.put(
      `${SALES_ORDERS_URL}cancel/${salesOrder_id}/`, {},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(voidSalesOrderSuccess());
        if (route) {
          if (route === 'mobileSalesOrders') {
            browserHistory.push('/mobileSalesOrders');
          } else {
            browserHistory.push('/salesOrders');
          }
        }
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(voidSalesOrderFailure(err));
      });
  };
}

export function voidSalesOrderSuccess() {
  return {
    type: VOID_SALES_ORDER_SUCCESS,
  };
}

export function voidSalesOrderFailure(response) {
  return {
    type: VOID_SALES_ORDER_FAILURE,
    payload: response,
  };
}

// fetch SO customer sales history
export function requestCustomerSalesHistory() {
  return {
    type: REQUEST_CUSTOMER_SALES_HISTORY,
  };
}

export function fetchCustomerSalesHistorySuccess(history) {
  return {
    type: FETCH_CUSTOMER_SALES_HISTORY_SUCCESS,
    payload: history,
  };
}

export function fetchCustomerSalesHistoryFailure(error) {
  return {
    type: FETCH_CUSTOMER_SALES_HISTORY_FAILURE,
    payload: error,
  };
}

export function fetchCustomerSalesHistory(customerId) {
  return (dispatch) => {
    dispatch(requestCustomerSalesHistory());
    return axios.get(
      `${CUSTOMER_SALES_HISTORY}${customerId}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCustomerSalesHistorySuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchCustomerSalesHistoryFailure(err));
      });
  };
}

// fetch SO customer order sc
export function fetchCustomerOrderSchedules() {
  return (dispatch) => {
    dispatch({ type: REQUEST_CUSTOMER_ORDER_SCHEDULES });
    axios.get(
      SALES_DASHBOARD_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCustomerOrderSchedulesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchCustomerOrderSchedulesFailure(err));
      });
  };
}

export function fetchCustomerOrderSchedulesByDate(date) {
  return (dispatch) => {
    dispatch({ type: REQUEST_CUSTOMER_ORDER_SCHEDULES });
    axios.get(
      SALES_DASHBOARD_URL + date,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCustomerOrderSchedulesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchCustomerOrderSchedulesFailure(err));
      });
  };
}

export function fetchCustomerOrderSchedulesSuccess(orderSchedules) {
  return {
    type: FETCH_CUSTOMER_ORDER_SCHEDULES_SUCCESS,
    payload: orderSchedules,
  };
}

export function fetchCustomerOrderSchedulesFailure(error) {
  return {
    type: FETCH_CUSTOMER_ORDER_SCHEDULES_FAILURE,
    payload: error,
  };
}

export function fetchTodaysOutgoingOrders() {
  return (dispatch) => {
    dispatch(requestTodaysOutgoingOrders());
    return axios.get(
      OUTGOING_ORDERS_BY_DATE_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchTodaysOutgoingOrdersSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchTodaysOutgoingOrdersFailure(err));
      });
  };
}

export function requestTodaysOutgoingOrders() {
  return {
    type: REQUEST_TODAYS_OUTGOING_ORDERS,
  };
}

export function fetchTodaysOutgoingOrdersSuccess(orders) {
  return {
    type: FETCH_TODAYS_OUTGOING_ORDERS_SUCCESS,
    payload: orders,
  };
}

export function fetchTodaysOutgoingOrdersFailure(error) {
  return {
    type: FETCH_TODAYS_OUTGOING_ORDERS_FAILURE,
    payload: error,
  };
}

export const podUpload = (salesorderId, data, success) => {
  axios({
    method: 'POST',
    data,
    url: `${ROOT_URL}v1/oversea-warehouse/upload-pod-files/${salesorderId}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then((response) => {
    success();
  }, (err) => {
    alert('error uploading pod file');
  });
}

export const uploadMSO = (data, success) => {
  axios({
    method: 'POST',
    data,
    url: `${ROOT_URL}v2/amzey_import_orders/`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then((response) => {
    success();
  }, (err) => {
    alert('error uploading mso order' + JSON.stringify(err.data || data));
  });
}

export const podUPloadSCM = (salesorderId, data, success) => {
  axios({
    method: 'POST',
    data,
    url: `${ROOT_URL}v1/sale/upload_pod_file/${salesorderId}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then((response) => {
    success();
  }, (err) => {
    alert('error uploading pod file');
  });
}

export function fetchOutgoingOrdersByDate({ fromDate, toDate }) {
  return (dispatch) => {
    dispatch(requestTodaysOutgoingOrders());
    return axios({
      method: 'get',
      url: OUTGOING_ORDERS_BY_DATE_URL,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: {
        start_date: fromDate,
        end_date: toDate,
      },
    }).then((response) => {
      dispatch(fetchTodaysOutgoingOrdersSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(fetchTodaysOutgoingOrdersFailure(err));
    });
  };
}

export function fetchSalesOrderLineWeights(line_id) {
  return (dispatch) => {
    dispatch(requestSalesOrderLineWeights());
    return axios.get(
      SALES_ORDER_LINE_WEIGHTS_URL + line_id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderLineWeightsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesOrderLineWeightsFailure(err));
      });
  };
}

export function requestSalesOrderLineWeights() {
  return {
    type: REQUEST_SALES_ORDER_LINE_WEIGHTS,
  };
}

export function fetchSalesOrderLineWeightsSuccess(weights) {
  return {
    type: FETCH_SALES_ORDER_LINE_WEIGHTS_SUCCESS,
    payload: weights,
  };
}

export function fetchSalesOrderLineWeightsFailure(error) {
  return {
    type: FETCH_SALES_ORDER_LINE_WEIGHTS_FAILURE,
    payload: error,
  };
}

export function setOrderLineWeights(line_id, lines) {
  const Weights = [];
  lines.map((row) => {
    Weights.push(parseFloat(row.Weight));
  });
  return (dispatch) => {
    dispatch(requestSetOrderLineWeights());
    return axios.post(
      SALES_ORDER_LINE_WEIGHTS_URL + line_id,
      {
        Weights,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(editSalesOrderLineWeightsSuccess());
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(editSalesOrderLineWeightsFailure(err));
      });
  };
}

export function requestSetOrderLineWeights() {
  return {
    type: REQUEST_SET_ORDER_LINE_WEIGHTS,
  };
}

export function editSalesOrderLineWeightsSuccess() {
  return {
    type: EDIT_SALES_ORDER_LINE_WEIGHTS_SUCCESS,
  };
}

export function editSalesOrderLineWeightsFailure(error) {
  return {
    type: EDIT_SALES_ORDER_LINE_WEIGHTS_FAILURE,
    payload: error,
  };
}

export function clearSalesOrderLineWeights() {
  return {
    type: CLEAR_SALES_ORDER_LINE_WEIGHTS,
  };
}

export function fetchSalesOrderForm() {
  return (dispatch) => {
    dispatch(requestSalesOrderForm());
    return axios.get(
      FETCH_SALES_ORDER_FORM_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderFormSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesOrderFormFailure(err));
      });
  };
}

export function requestSalesOrderForm() {
  return {
    type: REQUEST_SALES_ORDER_FORM,
  };
}

export function fetchSalesOrderFormSuccess(form) {
  return {
    type: FETCH_SALES_ORDER_FORM_SUCCESS,
    payload: form,
  };
}

export function fetchSalesOrderFormFailure(error) {
  return {
    type: FETCH_SALES_ORDER_FORM_FAILURE,
    payload: error,
  };
}

export function clearInventories() {
  return {
    type: CLEAR_INVENTORIES,
  };
}

export function fetchSalesCSV() {
  return (dispatch) => {
    dispatch({ type: REQUEST_SALES_CSV });
    return axios.post(
      `${ROOT_URL}v1/dashboard/salesiif/`,
      // DASHBOARD_URL + 'salescsv/',
      {
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesCSVSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesCSVFailure(err));
      });
  };
}

export function fetchSalesCSVSuccess(form) {
  return {
    type: FETCH_SALES_CSV_SUCCESS,
    payload: form,
  };
}

export function fetchSalesCSVFailure(error) {
  return {
    type: FETCH_SALES_CSV_FAILURE,
    payload: error,
  };
}

export function savePosSale({
  Order_id,
  Order_Num,
  Subtotal,
  FinalPrice,
  TaxRate,
  Sales_User,
  Warehouse_id,
  Note,
  POS_Order_Lines,
  SaleStatus,
}) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SAVE_POS_SALE });
    return axios.post(
      POS_SALE_URL,
      {
        Order_id,
        Order_Num,
        Subtotal,
        FinalPrice,
        TaxRate,
        Sales_User,
        Warehouse_id,
        Note,
        POS_Order_Lines,
        SaleStatus,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(change('pos', 'ProductNum', ''));
        dispatch(change('pos', 'Quantity', ''));
        dispatch(change('pos', 'CashCharge', ''));
        dispatch(change('pos', 'CheckCharge', ''));
        dispatch(change('pos', 'CreditCharge', ''));
        dispatch(change('pos', 'FinalCharge', ''));
        dispatch(savePosSaleSuccessful(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(savePosSaleFailure(err));
      });
  };
}

export function savePosSaleSuccessful(response) {
  return {
    type: SAVE_POS_SALE_SUCCESS,
  };
}

export function savePosSaleFailure(error) {
  return {
    type: SAVE_POS_SALE_FAILURE,
    payload: error,
  };
}

export function invalidCharacterEntered() {
  return {
    type: INVALID_CHARACTER_ENTERED,
  };
}

export function chargeNotMet() {
  return {
    type: CHARGE_NOT_MET,
  };
}

export function clearErrorMessageInPOS() {
  return {
    type: CLEAR_ERROR_MESSAGE_IN_POS,
  };
}

export function startNewOrder() {
  return {
    type: START_NEW_ORDER,
  };
}

export function startNewItem() {
  return (dispatch) => {
    dispatch(change('pos', 'ProductNum', ''));
    dispatch(change('pos', 'Quantity', ''));
  };
}

export function setSaleRowValue(CustomerLevel, form, row) {
  return (dispatch) => {
    dispatch(change(form, 'UnitPrice', row[`PriceLv${CustomerLevel}`] ? row[`PriceLv${CustomerLevel}`] : row.Price));
    dispatch(change(form, 'Weight', row.NetWeight));
  };
}

export function setSaleOrderProductValues(CustomerPrice, form, product) {
  return (dispatch) => {
    dispatch(change(form, 'UnitPrice', CustomerPrice));
    dispatch(change(form, 'Weight', product.NetWeight));
    dispatch(change(form, 'ProductCost', product.ProductCost));
    dispatch(change(form, 'PackageSize_1', product.PackageSize_1));
  };
}

export function setSaleFavoriteRowValue(title, form, row) {
  return (dispatch) => {
    dispatch(change(form, 'ProductInformation', title));
  };
}

export function setCredit(value) {
  return (dispatch) => {
    dispatch(change('salesOrderForm', 'creditRadios', value));
  };
}

export function setSubtotal(value) {
  return (dispatch) => {
    dispatch(change('salesOrderForm', 'Subtotal', value));
  };
}

export function resetFormInputs() {
  return (dispatch) => {
    dispatch(change('salesOrderForm', 'Quantity', '1'));
    dispatch(change('salesOrderForm', 'UnitPrice', ''));
    dispatch(change('salesOrderForm', 'ProductInformation', ''));
    dispatch(change('salesOrderForm', 'Weight', ''));
    dispatch(change('salesOrderForm', 'itemNotation', ''));
    dispatch(change('salesOrderForm', 'ProductCost', ''));

    dispatch(change('salesOrderForm', 'ReceivedQuantity', ''));
    dispatch(change('salesOrderForm', 'ShipmentID', ''));
    dispatch(change('salesOrderForm', 'ServiceType', ''));
    dispatch(change('salesOrderForm', 'CustomerRef', ''));
    dispatch(change('salesOrderForm', 'Unloader', ''));
    dispatch(change('salesOrderForm', 'TruckVendor', ''));

    dispatch(change('salesOrderForm', 'ISANum', ''));
    dispatch(change('salesOrderForm', 'BillablePallets', ''));
    dispatch(change('salesOrderForm', 'PalletQuantity', ''));
    dispatch(change('salesOrderForm', 'BoxQuantity', ''));
    dispatch(change('salesOrderForm', 'PieceQuantity', ''));
    dispatch(change('salesOrderForm', 'RealPallets', ''));
    dispatch(change('salesOrderForm', 'BoxPerPallet', ''));
    dispatch(change('salesOrderForm', 'FBACode', ''));
    dispatch(change('salesOrderForm', 'DispatchType', ''));
    dispatch(change('salesOrderForm', 'BoxVol', ''));
    dispatch(change('salesOrderForm', 'BoxLength', ''));
    dispatch(change('salesOrderForm', 'BoxWidth', ''));
    dispatch(change('salesOrderForm', 'BoxHeight', ''));
    dispatch(change('salesOrderForm', 'InnerLabelQty', ''));
    dispatch(change('salesOrderForm', 'OuterLabelQty', ''));

    dispatch(change('salesOrderForm', 'BoxWeight', ''));
    dispatch(change('salesOrderForm', 'RepackedPalletQuantity', ''));
    dispatch(change('salesOrderForm', 'PalletLength', ''));
    dispatch(change('salesOrderForm', 'PalletWidth', ''));
    dispatch(change('salesOrderForm', 'PalletHeight', ''));
    dispatch(change('salesOrderForm', 'PalletVol', ''));

    dispatch(change('salesOrderForm', 'UnitQuantity', ''));
    dispatch(change('salesOrderForm', 'PerBoxQty', ''));
    dispatch(change('salesOrderForm', 'UnitLength', ''));
    dispatch(change('salesOrderForm', 'UnitWidth', ''));
    dispatch(change('salesOrderForm', 'UnitHeight', ''));
    dispatch(change('salesOrderForm', 'UnitVol', ''));

    dispatch(change('salesOrderForm', 'PalletWeight', ''));
    dispatch(change('salesOrderForm', 'IsOversize', ''));
    dispatch(change('salesOrderForm', 'IsOverweight', ''));
    dispatch(change('salesOrderForm', 'PortDray', ''));
    dispatch(change('salesOrderForm', 'DrayageTrucker', ''));
    dispatch(change('salesOrderForm', 'TotalShippingWeight', 0));
    dispatch(change('salesOrderForm', 'Location', ''));

    dispatch(change('salesOrderForm', 'Zone', ''));
    dispatch(change('salesOrderForm', 'Section', ''));
    dispatch(change('salesOrderForm', 'Bin', ''));

    dispatch(change('salesOrderForm', 'FBARoute', ''));
    dispatch(change('salesOrderForm', 'DimUnit', ''));

    // dispatch(change('salesOrderForm', 'VendorStyleNum', ''));
    // dispatch(change('salesOrderForm', 'TJXStyleNum', ''));
    // dispatch(change('salesOrderForm', 'LineDescription', ''));
    // dispatch(change('salesOrderForm', 'UPC', ''));
    // dispatch(change('salesOrderForm', 'Color', ''));
    // dispatch(change('salesOrderForm', 'Size', ''));
    // dispatch(change('salesOrderForm', 'TotalUnits', ''));
    dispatch(change('salesOrderForm', 'StoreReady', ''));
    dispatch(change('salesOrderForm', 'PalletStackable', ''));
    dispatch(change('salesOrderForm', 'Preticketed', ''));
    dispatch(change('salesOrderForm', 'CantonNum', ''));
    dispatch(change('salesOrderForm', 'OriginCountry', ''));

    dispatch(change('salesOrderForm', 'PackageSize_1', ''));
    dispatch(change('salesOrderForm', 'jmlPackageSize_1', ''));
    dispatch(change('salesOrderForm', 'jmlBox', ''));
    dispatch(change('salesOrderForm', 'WeightUnit', ''));
    dispatch(change('salesOrderForm', 'TrailerNum', ''));
    dispatch(change('salesOrderForm', 'POList', ''));
    dispatch(change('salesOrderForm', 'POD', ''));
  };
}

export function setValue(form, field, value) {
  return (dispatch) => {
    dispatch(change(form, field, value));
  };
}

export function fetchPOSDraft(pk) {
  return (dispatch) => {
    dispatch({ type: REQUEST_DRAFT_DETAILS });
    return axios.get(
      POS_SALE_URL + pk,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchDraftDetailsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchDraftDetailsFailure(err));
      });
  };
}

export function fetchDraftDetailsSuccess(details) {
  return {
    type: LOAD_DRAFT_SUCCESS,
    payload: details,
  };
}

export function fetchDraftDetailsFailure(error) {
  return {
    type: LOAD_DRAFT_FAILURE,
    payload: error,
  };
}

export function fetchDrafts() {
  return (dispatch) => {
    dispatch({ type: REQUEST_DRAFTS });
    return axios.get(
      `${POS_SALE_URL}draft`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchDraftsSuccessful(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchDraftsFailure(err));
      });
  };
}

export function fetchDraftsSuccessful(drafts) {
  return {
    type: FETCH_DRAFTS_SUCCESSFUL,
    payload: drafts,
  };
}

export function fetchDraftsFailure(error) {
  return {
    type: FETCH_DRAFTS_FAILURE,
    payload: error,
  };
}

export function clearForm() {
  return (dispatch) => {
    dispatch(change('pos', 'ProductNum', ''));
    dispatch(change('pos', 'Quantity', ''));
    dispatch(change('pos', 'CashCharge', ''));
    dispatch(change('pos', 'CheckCharge', ''));
    dispatch(change('pos', 'CreditCharge', ''));
    dispatch(change('pos', 'FinalCharge', ''));
  };
}

// export function createSalesReturn({
//             Promo,
//             Tax,
//             ReStockingFee,
//             Note
//           },{
//             SalesInvoiceCompleted_id,
//             CustomerNum
//           },
//           TotalPrice,
//           Sales_Return_Line,
//           CustomerNumWithoutInvoice,
//           ReturnStatus) {
//             let FinalPrice = (parseFloat(Promo) || 0) + (parseFloat(Tax) || 0) + (parseFloat(ReStockingFee) || 0) + (parseFloat(TotalPrice) || 0)
//             let ReturnDate = new Date;
//             if(CustomerNumWithoutInvoice)
//               CustomerNumWithoutInvoice = CustomerNumWithoutInvoice.value || CustomerNumWithoutInvoice;
//             CustomerNum = CustomerNum || CustomerNumWithoutInvoice;
//             return dispatch => {
// dispatch({ type: REQUEST_CREATING_SALES_RETURN });
// axios.post(SALES_RETURN_URL,
//     {
//         Promo,
//         Tax,
//         ReStockingFee,
//         TotalPrice,
//         FinalPrice,
//         SalesInvoiceCompleted_id,
//         CustomerNum,
//         ReturnDate,
//         Sales_Return_Line,
//         ReturnStatus,
//         Note
//     },
//     {
//         headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
//     }
// )
// .then(response => {
//     dispatch(createSalesReturnSuccess());
//     browserHistory.push('/customerReturn');
// })
// .catch(response => {
//     dispatch(createSalesReturnFailure(response));
// })
//   }
// }

export function createCreditIssue(Deliver_Customer_id, TotalPrice, TaxRate, Tax, CRV, RestockingFee, FinalPrice, Note, invoice, PostingDate) {
  return (dispatch) => {
    dispatch({ type: REQUEST_CREATING_SALES_RETURN });
    const Sales_Return_Line = [];
    for (let i = 0; i < invoice.rows.length; i++) {
      const newEntry = {};
      newEntry.Product_id = invoice.rows[i].Product_id;
      newEntry.Name = invoice.rows[i].Name;
      newEntry.Description = invoice.rows[i].Description;
      newEntry.ProductType = invoice.rows[i].ProductType;
      newEntry.UnitPrice = parseFloat(invoice.rows[i].UnitPrice);
      newEntry.ReturnQuantity = parseFloat(invoice.rows[i].ReturnQuantity);
      newEntry.ReturnCRV = parseFloat(invoice.rows[i].CRV);
      newEntry.ReturnTotalPrice = parseFloat(invoice.rows[i].ReturnTotalPrice);
      newEntry.ReturnWeight = parseFloat(invoice.rows[i].ReturnWeight);
      newEntry.ReturnWeightsList = invoice.rows[i].Weights;
      newEntry.ReturnReason = invoice.rows[i].ReturnReason;
      newEntry.IsProductReturned = invoice.rows[i].IsProductReturned;
      Sales_Return_Line.push(newEntry);
    }
    TotalPrice = parseFloat(TotalPrice);
    Tax = parseFloat(Tax);
    CRV = parseFloat(CRV);
    RestockingFee = parseFloat(RestockingFee);
    FinalPrice = parseFloat(FinalPrice);
    axios.post(
      SALES_ISSUE_CREDIT_URL,
      {
        Deliver_Customer_id,
        Sales_Return_Line,
        TotalPrice,
        TaxRate,
        Tax,
        CRV,
        RestockingFee,
        FinalPrice,
        Note,
        PostingDate: convertUtcDate(PostingDate),
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(createCreditIssueSuccess());
        browserHistory.push('/inventoryReturn');
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(createCreditIssueFailure(err));
      });
  };
}


export function createCreditIssueSuccess() {
  return {
    type: CREATE_SALES_RETURN_SUCCESS,
  };
}

export function createCreditIssueFailure(error) {
  return {
    type: CREATE_SALES_RETURN_FAILURE,
    payload: error,
  };
}

export function createSalesReturn(InvoiceNum, TotalPrice, Tax, CRV, RestockingFee, FinalPrice, Note, invoice, SalesInvoice_id, CreditInvoiceNum, PostingDate, Redeliver = false, ReturnedSavings) {
  return (dispatch) => {
    dispatch({ type: REQUEST_CREATING_SALES_RETURN });
    const SRNum = `${InvoiceNum}R`;
    const Sales_Return_Line = [];
    for (let i = 0; i < invoice.selectedRows.length; i++) {
      const newEntry = {};
      newEntry.Product_id = invoice.selectedRows[i].Product_id;
      newEntry.SalesInvoiceLine_id = invoice.selectedRows[i].SalesInvoiceLine_id;
      newEntry.Name = invoice.selectedRows[i].Name;
      newEntry.Description = invoice.selectedRows[i].Description;
      newEntry.ProductType = invoice.selectedRows[i].ProductType;
      newEntry.UnitPrice = parseFloat(invoice.selectedRows[i].UnitPrice);
      newEntry.ReturnQuantity = parseFloat(invoice.selectedRows[i].ReturnQuantity);
      newEntry.ReturnCRV = parseFloat(invoice.selectedRows[i].ReturnCRV);
      newEntry.ReturnTotalPrice = parseFloat(invoice.selectedRows[i].ReturnTotalPrice);
      newEntry.ReturnReason = invoice.selectedRows[i].ReturnReason;
      newEntry.ReturnWeight = parseFloat(invoice.selectedRows[i].ReturnWeight);
      if (invoice.selectedRows[i].ProductType === 'Non-Fixed') {
        newEntry.ReturnWeightsList = invoice.selectedRows[i].ReturnWeightsList;
      }
      if(isJML) {
        newEntry.ReturnBox = invoice.selectedRows[i].ReturnBox;
        newEntry.jmlPackageSize1 = invoice.selectedRows[i].jmlPackageSize1;
        newEntry.Batch_id = invoice.selectedRows[i].Batch_id;
      }
      Sales_Return_Line.push(newEntry);
    }
    TotalPrice = parseFloat(TotalPrice);
    ReturnedSavings = parseFloat(ReturnedSavings);
    Tax = parseFloat(Tax);
    CRV = parseFloat(CRV);
    RestockingFee = parseFloat(RestockingFee);
    FinalPrice = parseFloat(FinalPrice);
    axios.post(
      `${SALES_RETURN_URL}?SalesInvoice_id=${SalesInvoice_id}&Redeliver=${Redeliver}`,
      {
        SRNum,
        Sales_Return_Line,
        TotalPrice,
        ReturnedSavings,
        Tax,
        CRV,
        RestockingFee,
        FinalPrice,
        Note,
        PostingDate: convertUtcDate(PostingDate),
        CreditInvoiceNum: CreditInvoiceNum || '',
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(createSalesReturnSuccess());
        browserHistory.push('/inventoryReturn');
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(createSalesReturnFailure(err));
      });
  };
}


export function createSalesReturnSuccess() {
  return {
    type: CREATE_SALES_RETURN_SUCCESS,
  };
}

export function createSalesReturnFailure(error) {
  return {
    type: CREATE_SALES_RETURN_FAILURE,
    payload: error,
  };
}

export function editSalesReturn(SRNum, TotalPrice, Tax, CRV, RestockingFee, FinalPrice, Note, invoice, SalesReturn_id, CreditInvoiceNum, PostingDate, ReturnedSavings) {
  return (dispatch) => {
    dispatch({ type: REQUEST_CREATING_SALES_RETURN });
    const Sales_Return_Line = [];
    for (let i = 0; i < invoice.selectedRows.length; i++) {
      const newEntry = {};
      newEntry.Product_id = invoice.selectedRows[i].Product_id;
      newEntry.SalesInvoiceLine_id = invoice.selectedRows[i].SalesInvoiceLine_id;
      newEntry.Name = invoice.selectedRows[i].Name;
      newEntry.Description = invoice.selectedRows[i].Description;
      newEntry.ProductType = invoice.selectedRows[i].ProductType;
      newEntry.UnitPrice = parseFloat(invoice.selectedRows[i].UnitPrice);
      newEntry.ReturnQuantity = parseFloat(invoice.selectedRows[i].ReturnQuantity);
      newEntry.ReturnCRV = parseFloat(invoice.selectedRows[i].ReturnCRV);
      newEntry.ReturnTotalPrice = parseFloat(invoice.selectedRows[i].ReturnTotalPrice);
      newEntry.ReturnReason = invoice.selectedRows[i].ReturnReason;
      newEntry.SalesReturnLine_id = invoice.selectedRows[i].SalesReturnLine_id;
      if (invoice.selectedRows[i].ProductType === 'Non-Fixed') {
        newEntry.ReturnWeight = parseFloat(invoice.selectedRows[i].ReturnWeight);
        newEntry.ReturnWeightsList = invoice.selectedRows[i].ReturnWeightsList;
      }
      if(isJML) {
        newEntry.ReturnBox = invoice.selectedRows[i].ReturnBox ? Number(invoice.selectedRows[i].ReturnBox) : 0;
        newEntry.jmlPackageSize1 = invoice.selectedRows[i].jmlPackageSize1;
        newEntry.Batch_id = invoice.selectedRows[i].Batch_id;
      }
      Sales_Return_Line.push(newEntry);
    }
    TotalPrice = parseFloat(TotalPrice);
    ReturnedSavings = parseFloat(ReturnedSavings);
    Tax = parseFloat(Tax);
    CRV = parseFloat(CRV);
    RestockingFee = parseFloat(RestockingFee);
    FinalPrice = parseFloat(FinalPrice);
    axios.put(
      SALES_RETURN_URL + SalesReturn_id,
      {
        SRNum,
        Sales_Return_Line,
        TotalPrice,
        ReturnedSavings,
        Tax,
        CRV,
        RestockingFee,
        FinalPrice,
        Note,
        PostingDate: convertUtcDate(PostingDate),
        CreditInvoiceNum: CreditInvoiceNum || '',
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(editSalesReturnSuccess());
        browserHistory.push('/inventoryReturn');
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(editSalesReturnFailure(err));
      });
  };
}

export function editSalesReturnSuccess() {
  return {
    type: CREATE_SALES_RETURN_SUCCESS,
  };
}

export function editSalesReturnFailure(error) {
  return {
    type: CREATE_SALES_RETURN_FAILURE,
    payload: error,
  };
}

export function fetchSalesReturnDetail(id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SALES_RETURN_DETAIL });
    return axios.get(
      SALES_RETURN_URL + id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesReturnDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesReturnDetailFailure(err));
      });
  };
}

export function fetchSalesReturnDetailSuccess(form) {
  return {
    type: FETCH_SALES_RETURN_DETAIL_SUCCESS,
    payload: form,
  };
}

export function fetchSalesReturnDetailFailure(error) {
  return {
    type: FETCH_SALES_RETURN_DETAIL_FAILURE,
    payload: error,
  };
}

export function fetchInventoryReturns(SalesReturn_id__ReturnDate__gte, SalesReturn_id__ReturnDate__lte, days) {
  const dates = toFromDates(days, SalesReturn_id__ReturnDate__gte, SalesReturn_id__ReturnDate__lte);
  return (dispatch) => {
    dispatch({ type: REQUEST_INVENTORY_RETURN });
    return axios.get(
      `${SALES_RETURN_URL}?PostingDate__gte=${dates.fromDate
      }&PostingDate__lte=${dates.toDate}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchInventoryReturnsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchInventoryReturnsFailure(err));
      });
  };
}

export function fetchInventoryReturnsSuccess(form) {
  return {
    type: FETCH_INVENTORY_RETURN_SUCCESS,
    payload: form,
  };
}

export function fetchInventoryReturnsFailure(error) {
  return {
    type: FETCH_INVENTORY_RETURN_FAILURE,
    payload: error,
  };
}

export function fetchInventoryReturnsDetails(SalesReturn_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_INVENTORY_RETURN_DETAILS });
    return axios.get(
      SALES_RETURN_URL + SalesReturn_id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchInventoryReturnsDetailsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchInventoryReturnsDetailsFailure(err));
      });
  };
}

export function fetchInventoryReturnsDetailsSuccess(form) {
  return {
    type: FETCH_INVENTORY_RETURN_DETAILS_SUCCESS,
    payload: form,
  };
}

export function fetchInventoryReturnsDetailsFailure(error) {
  return {
    type: FETCH_INVENTORY_RETURN_DETAILS_FAILURE,
    payload: error,
  };
}

export function editInventoryReturns(SalesReturnLine) {
  return (dispatch) => {
    dispatch({ type: EDIT_INVENTORY_RETURN });
    return axios.put(
      `${SALES_RETURN_URL}inventory/`,
      {
        SalesReturnLine,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(editInventoryReturnsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(editInventoryReturnsFailure(err));
      });
  };
}

export function editInventoryReturnsSuccess(form) {
  return {
    type: EDIT_INVENTORY_RETURN_SUCCESS,
    payload: form,
  };
}

export function editInventoryReturnsFailure(error) {
  return {
    type: EDIT_INVENTORY_RETURN_FAILURE,
    payload: error,
  };
}

export function fetchCustomerPrices(pk) {
  return (dispatch) => {
    dispatch({ type: REQUEST_CUSTOMER_PRICES });
    return axios.get(
      INVENTORIES_URL + pk,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCustomerPricesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchCustomerPricesFailure(err));
      });
  };
}

export function fetchCustomerPricesSuccess(prices) {
  return {
    type: FETCH_CUSTOMER_PRICES_SUCCESS,
    payload: prices,
  };
}

export function fetchCustomerPricesFailure(error) {
  return {
    type: FETCH_CUSTOMER_PRICES_FAILURE,
    payload: error,
  };
}

export function fetchCurrencyRatesSuccess(rates) {
  return {
    type: FETCH_CURRENCY_RATES_SUCCESS,
    payload: rates,
  };
}

export function fetchCurrencyRatesFailure(error) {
  return {
    type: FETCH_CURRENCY_RATES_FAILURE,
    payload: error,
  };
}

export function fetchCurrencyRates() {
  return (dispatch) => {
    dispatch({ type: REQUEST_CURRENCY_RATES });
    return axios({
      method: 'get',
      url: CURRENCY_RATES_URL,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((response) => {
        dispatch(fetchCurrencyRatesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchCurrencyRatesFailure(err));
      });
  };
}

function editMultiCurrenciesSuccess(data) {
  return {
    type: EDIT_MULTI_CURRENCIES_SUCCESS,
    payload: data,
  };
}

function editMultiCurrenciesFailure(error) {
  return {
    type: EDIT_MULTI_CURRENCIES_FAILURE,
    payload: error,
  };
}

export function editMultiCurrencies(currencies) {
  return (dispatch) => {
    dispatch({ type: EDIT_MULTI_CURRENCIES });
    return axios({
      method: 'put',
      url: CURRENCY_RATES_URL,
      data: currencies,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((response) => {
        dispatch(editMultiCurrenciesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(editMultiCurrenciesFailure(err));
      });
  };
}

export function fetchTaxRatesSuccess(rates) {
  return {
    type: FETCH_TAX_RATES_SUCCESS,
    payload: rates,
  };
}

export function fetchTaxRatesFailure(error) {
  return {
    type: FETCH_TAX_RATES_FAILURE,
    payload: error,
  };
}

export function fetchTaxRates(pk) {
  if (pk === undefined) { pk = ''; }
  return (dispatch) => {
    dispatch({ type: REQUEST_TAX_RATES });
    return axios({
      method: 'get',
      url: TAX_RATES_URL + pk,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((response) => {
        dispatch(fetchTaxRatesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchTaxRatesFailure(err));
      });
  };
}

function editMultiTaxesSuccess(data) {
  return {
    type: EDIT_MULTI_TAXES_SUCCESS,
    payload: data,
  };
}

function editMultiTaxesFailure(error) {
  return {
    type: EDIT_MULTI_TAXES_FAILURE,
    payload: error,
  };
}

export function editMultiTaxes(taxes) {
  return (dispatch) => {
    dispatch({ type: EDIT_MULTI_TAXES });
    return axios({
      method: 'post',
      url: TAX_RATES_URL,
      data: taxes,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((response) => {
        dispatch(editMultiTaxesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(editMultiTaxesFailure(err));
      });
  };
}

function deleteTaxSuccess(data) {
  return {
    type: DELETE_TAX_SUCCESS,
    payload: data,
  };
}

function deleteTaxFailure(error) {
  return {
    type: DELETE_TAX_FAILURE,
    payload: error,
  };
}

export function deleteTax(taxAreaId) {
  return (dispatch) => {
    dispatch({ type: DELETE_TAX });
    return axios({
      method: 'delete',
      url: TAX_RATES_URL + taxAreaId,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((response) => {
        dispatch(deleteTaxSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(deleteTaxFailure(err));
      });
  };
}

export function fetchOverallSalesPerformance(type) {
  const start_date = moment().toISOString();
  return (dispatch) => {
    dispatch({ type: REQUEST_OVERALL_SALES_PERFORMANCE });
    return axios({
      method: 'get',
      url: OVERALL_SALES_PERFORMANCE_URL,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: {
        type,
        start_date,
      },
    }).then((response) => {
      dispatch(fetchOverallSalesPerformanceSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(fetchOverallSalesPerformanceFailure(err));
    });
  };
}

export function fetchOverallSalesPerformanceSuccess(data) {
  return {
    type: FETCH_OVERALL_SALES_PERFORMANCE_SUCCESS,
    payload: data,
  };
}

export function fetchOverallSalesPerformanceFailure(error) {
  return {
    type: FETCH_OVERALL_SALES_PERFORMANCE_FAILURE,
    payload: error,
  };
}

export function fetchPosReport(type, days, fromDate, toDate, division, num, salesID) {
  if (salesID == null) { salesID = ''; } else {
    salesID = `&Order_id__Sales_user=${salesID}`;
  }
  const dates = toFromDates(days, fromDate, toDate);

  if (days == null || days == -1 || days == 'none') days = '';
  else days = `/${days}`;

  return (dispatch) => {
    dispatch({ type: REQUEST_POS_REPORT });
    return axios.get(
      `${POS_REPORT_URL + type + days}/` +
      `?Order_id__Date__gte=${dates.fromDate}&Order_id__Date__lte=${dates.toDate}${division}${num}${salesID}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPosReportSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchPosReportFailure(err));
      });
  };
}

export function fetchPosReportSuccess(results) {
  return {
    type: FETCH_POS_REPORT_SUCCESS,
    payload: results,
  };
}

export function fetchPosReportFailure(error) {
  return {
    type: FETCH_POS_REPORT_FAILURE,
    payload: error,
  };
}


export function fetchSalesInventoryInfo(customer_id, type, value) {
  if (value == null) value = ' ';
  return (dispatch) => {
    dispatch({ type: REQUEST_SALES_INVENTORY_INFO });
    return axios.get(
      `${SALES_INVENTORY_INFO_URL + customer_id}/?${type}=${value}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesInventoryInfoSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesInventoryInfoFailure(err));
      });
  };
}

export function fetchSalesInventoryInfoSuccess(info) {
  return {
    type: FETCH_SALES_INVENTORY_INFO_SUCCESS,
    payload: info,
  };
}

export function fetchSalesInventoryInfoFailure(error) {
  return {
    type: FETCH_SALES_INVENTORY_INFO_FAILURE,
    payload: error,
  };
}

export function fetchSalesCustomerDetail(pk, SalesOrder_id, isShippingCustomer) {
  const url = SALES_CUSTOMER_URL + ((SalesOrder_id) ? (`${SalesOrder_id}/order`) : pk);
  return (dispatch) => {
    if (isShippingCustomer) {
      dispatch({ type: REQUEST_SALES_SHIPPING_CUSTOMER_DETAIL });
    } else {
      dispatch({ type: REQUEST_SALES_CUSTOMER_DETAIL });
    }
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        if (isShippingCustomer) {
          dispatch(fetchShippingCustomerDetailSuccess(response));
        } else {
          dispatch(fetchSalesCustomerDetailSuccess(response));
        }
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesCustomerDetailFailure(err));
      });
  };
}

export function fetchShippingCustomerDetailSuccess(details) {
  return { type: FETCH_SALES_SHIPPING_CUSTOMER_DETAIL_SUCCESS, payload: details };
}

export function fetchSalesCustomerDetailSuccess(details) {
  return { type: FETCH_SALES_CUSTOMER_DETAIL_SUCCESS, payload: details };
}

export function fetchSalesCustomerDetailFailure(error) {
  return { type: FETCH_SALES_CUSTOMER_DETAIL_FAILURE, payload: error };
}

export function fetchAllShipping() {
  return (dispatch) => {
    dispatch({ type: REQUEST_SHIPPING_DETAIL });
    return axios.get(
      SHIPPING_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchAllShippingDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchAllShippingDetailFailure(err));
      });
  };
}

export function fetchAllShippingDetailSuccess(details) {
  return {
    type: FETCH_SHIPPING_DETAIL_SUCCESS,
    payload: details,
  };
}

export function fetchAllShippingDetailFailure(error) {
  return {
    type: FETCH_SHIPPING_DETAIL_FAILURE,
    payload: error,
  };
}

export function fetchPurchasesVendorDetail(Vendor_id) {
  const url = `${PURCHASES_VENDOR_URL + Vendor_id}/`;
  return (dispatch) => {
    dispatch({ type: REQUEST_PURCHASES_VENDOR_DETAIL });
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPurchasesVendorDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchPurchasesVendorDetailFailure(err));
      });
  };
}

export function fetchPurchasesVendorDetailSuccess(details) {
  return {
    type: FETCH_PURCHASES_VENDOR_DETAIL_SUCCESS,
    payload: details,
  };
}

export function fetchPurchasesVendorDetailFailure(error) {
  return {
    type: FETCH_PURCHASES_VENDOR_DETAIL_FAILURE,
    payload: error,
  };
}

export function clearSalesCustomerDetails() {
  return {
    type: CLEAR_SALES_CUSTOMER_DETAILS,
  };
}

export function fetchItemSalesHistory(Customer_id, Product_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_ITEM_SALES_HISTORY });
    return axios.get(
      `${ITEM_HISTORY_URL + Customer_id}/${Product_id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchItemSalesHistorySuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchItemSalesHistoryFailure(err));
      });
  };
}

export function fetchItemSalesHistorySuccess(hist) {
  return {
    type: FETCH_ITEM_SALES_HISTORY_SUCCESS,
    payload: hist,
  };
}

export function fetchItemSalesHistoryFailure(error) {
  return {
    type: FETCH_ITEM_SALES_HISTORY_FAILURE,
    payload: error,
  };
}

export function fetchCustomerFrequent(Customer_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_CUSTOMER_FREQUENT });
    return axios.get(
      FREQUENT_ITEMS_URL + Customer_id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCustomerFrequentSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchCustomerFrequentFailure(err));
      });
  };
}

export function fetchInboundProducts() {
  return (dispatch) => {
    dispatch({ type: REQUEST_CUSTOMER_FREQUENT });
    return axios.get(
      INBOUND_PRODUCTS_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCustomerFrequentSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchCustomerFrequentFailure(err));
      });
  };
}

export function fetchCustomerFrequentSuccess(items) {
  return {
    type: FETCH_CUSTOMER_FREQUENT_SUCCESS,
    payload: items,
  };
}

export function fetchCustomerFrequentFailure(error) {
  return {
    type: FETCH_CUSTOMER_FREQUENT_FAILURE,
    payload: error,
  };
}

export function initializeForm(data, fields, Form) {
  return (dispatch) => {
    dispatch(initialize(Form, data, fields));
  };
}

export function setSalesOrdersFilter(data) {
  return {
    type: SET_SALES_ORDERS_FILTER,
    payload: data,
  };
}

export function fetchSalesPerformance(salesType, days, fromDate, toDate, type, productNum, group, category, aggregate) {
  const dates = toFromDates(days, fromDate, toDate);
  if (salesType == 'salesorder') {
    fromDate = `SalesInvoice_id__DispatchDate__gte=${dates.fromDate}`;
    toDate = `SalesInvoice_id__DispatchDate__lte=${dates.toDate}`;
  } else if (salesType == 'posorder') {
    fromDate = `Order_id__Date__gte=${dates.fromDate}`;
    toDate = `Order_id__Date__lte=${dates.toDate}`;
  } else if (salesType == 'all') {
    fromDate = `date__gte=${dates.fromDate}`;
    toDate = `date__lte=${dates.toDate}`;
  }
  if (productNum) {
    productNum = `&Product_id__ProductNum=${productNum}`;
    group = '';
    category = '';
    aggregate = '';
  } else {
    productNum = '';
    if (group) {
      group = `&Product_id__ProductGroup_id=${group}`;
    } else {
      group = '';
    }
    if (category) {
      category = `&Product_id__ProductCategory1_id=${category}`;
    } else {
      category = '';
    }
    if (aggregate) {
      aggregate = `&Aggregate=${aggregate}`;
    } else {
      aggregate = '';
    }
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_SALES_PERFORMANCE });
    return axios.get(
      `${SALES_PERFORMANCE_URL + type}/${salesType}/?${fromDate}&${toDate}${productNum}${group}${category}${aggregate}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesPerformanceSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesPerformanceFailure(err));
      });
  };
}

export function fetchSalesPerformanceSuccess(data) {
  return {
    type: REQUEST_SALES_PERFORMANCE_SUCCESS,
    payload: data,
  };
}

export function fetchSalesPerformanceFailure(error) {
  return {
    type: REQUEST_SALES_PERFORMANCE_FAILURE,
    payload: error,
  };
}

export function fetchSalesOrdersByFilter(postingDateGT, postingDateLT, days, status, user, productNum, route) {
  const url = (route == 'salesOrders') ? SALES_ORDERS_URL : MOBILE_SALES_ORDERS_URL;
  const dates = toFromDates(days, postingDateGT, postingDateLT);
  if (status == 'all') {
    status = '';
  } else {
    status = `&SaleStatus=${status}`;
  }
  if (user) {
    user = `&Sales_User_id=${user}`;
  } else {
    user = '';
  }

  let belongWarehouse = ``;
  if ( isAFM ){
    if (!localStorage.getItem('warehouseLocation') || localStorage.getItem('warehouseLocation') === '') {
      belongWarehouse = ``;
    } else {
      belongWarehouse = `&BelongWarehouse=${localStorage.getItem('warehouseLocation')}`;
    }
  }

  if (productNum) {
    productNum = `&ProductNum=${productNum}`;
  } else {
    productNum = '';
  }
  return (dispatch) => {
    dispatch(requestSalesOrders());
    return axios.get(
      `${url}search/` + `?OrderDate__gte=${dates.fromDate
      }&OrderDate__lte=${dates.toDate}${status}${user}${productNum}${belongWarehouse}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrdersSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesOrdersFailure(err));
      });
  };
}

export function fetchSalesDashboardDetail() {
  return (dispatch) => {
    dispatch({ type: REQUEST_SALES_DASHBOARD_DETAIL });
    return axios.get(
      `${DASHBOARD_URL}salesdashboard/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesDashboardDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesDashboardDetailFailure(err));
      });
  };
}

export function requestSalesDashboardDetail() {
  return {
    type: REQUEST_SALES_DASHBOARD_DETAIL,
  };
}

export function fetchSalesDashboardDetailSuccess(dashboardSalesDetail) {
  return {
    type: FETCH_SALES_DASHBOARD_DETAIL_SUCCESS,
    payload: dashboardSalesDetail,
  };
}

export function fetchSalesDashboardDetailFailure(error) {
  return {
    type: FETCH_SALES_DASHBOARD_DETAIL_FAILURE,
    payload: error,
  };
}

export function loadsPost(pk) {
  return dispatch => axios.get(
    `${SALES_LOADSPOST_URL + pk}/`,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    },
  );
}

export function fetchSalesLevels() {
  return (dispatch) => {
    dispatch({ type: REQUEST_SALES_LEVELS });
    return axios.get(
      SALES_LEVELS_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesLevelsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesLevelsFailure(err));
      });
  };
}

export function fetchSalesLevelsSuccess(levels) {
  return {
    type: FETCH_SALES_LEVELS_SUCCESS,
    payload: levels,
  };
}

export function fetchSalesLevelsFailure(error) {
  return {
    type: FETCH_SALES_LEVELS_FAILURE,
    payload: error,
  };
}


/* Payment refund for MSO */
/* id: MSO id */
export function requestSORefund(id, props) {
  return (dispatch) => {
    dispatch(requestingSORefund());
    const token = localStorage.getItem('token');
    const data = {
      Amount: props.refundAmount * 100,
      Reason: props.refundReason,
    };
    return axios({
      method: 'post',
      url: `${SALES_ORDERS_REFUND}${id}/refund`,
      headers: { Authorization: `Bearer ${token}` },
      data,
    })
      .then((response) => {
        dispatch(requestSORefundSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(requestSORefundFailure(err));
      });
  };
}

export function requestingSORefund() {
  return {
    type: REQUEST_REFUND,
  };
}

export function requestSORefundSuccess(data) {
  return {
    type: REQUEST_REFUND_SUCCESS,
    payload: data,
  };
}

export function requestSORefundFailure(error) {
  return {
    type: REQUEST_REFUND_FAILURE,
    payload: error,
  };
}

export function voidReturn(SalesReturn_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_RETURN_VOID });
    return axios.post(
      `${SALES_RETURN_URL + SalesReturn_id}/void`,
      {
        SalesReturn_id,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchReturnsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchReturnsFailure(err));
      });
  };
}

export function completeReturn(SalesReturn_id, InvoiceDetails) {
  const Sales_Return_Line = [];
  const newEntry = {};
  for (let i = 0; i < InvoiceDetails.length; i++) {
    newEntry.SalesReturnLine_id = InvoiceDetails[i].SalesReturnLine_id;
    newEntry.RestockQuantity = InvoiceDetails[i].RestockQuantity;
    newEntry.RestockWeight = (InvoiceDetails[i].RestockWeight) ? InvoiceDetails[i].RestockWeight : 0;
    // Sales_Return_Line.push(newEntry);
    if(isJML) {
      Sales_Return_Line.push({
        SalesReturnLine_id: InvoiceDetails[i].SalesReturnLine_id, 
        RestockBox: InvoiceDetails[i].RestockBox?Number(InvoiceDetails[i].RestockBox) : 0, 
        RestockQuantity: InvoiceDetails[i].RestockQuantity, 
        RestockWeight: (InvoiceDetails[i].RestockWeight) ? InvoiceDetails[i].RestockWeight : 0,
        Batch_id: InvoiceDetails[i].Batch_id,
        jmlPackageSize1: InvoiceDetails[i].jmlPackageSize1,
      });
    } else {
      Sales_Return_Line.push({SalesReturnLine_id: InvoiceDetails[i].SalesReturnLine_id, RestockQuantity: InvoiceDetails[i].RestockQuantity, RestockWeight: (InvoiceDetails[i].RestockWeight) ? InvoiceDetails[i].RestockWeight : 0});
    }
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_RETURN_COMPLETE });
    return axios.post(
      `${SALES_RETURN_URL + SalesReturn_id}/complete`,
      {
        Sales_Return_Line,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchReturnsSuccess(response));
        browserHistory.push('/inventoryReturn');
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchReturnsFailure(err));
        console.log('ERROR IN response');
      });
  };
}

export function fetchReturnsSuccess(data) {
  return {
    type: FETCH_RETURN_SUCCESS,
    payload: data,
  };
}
export function fetchReturnsFailure(error) {
  return {
    type: FETCH_RETURN_FAILURE,
    payload: error,
  };
}

export function fetchSalesOrderProductByID(id, customer_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PRODUCT_BY_ID });
    return axios.get(
      `${SALES_ORDER_PRODUCT_BY_ID_URL}${customer_id}/?Product_id=${id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderProductByIDSuccesful(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesOrderProductByIDFailure(err));
      });
  };
}

export const fetchBatchesByID = (Product_id, isSO = false) => dispatch => {
  let url = `${INVENTORY_BATCH_URL}?product=${Product_id}&belong_warehouse=false`;
  if(isJML && isSO) {
    url += `&is_so=1`
  }
  return axios.get( 
    url,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    },
  )
    .then((response) => {
      dispatch({
        type: SALES_ORDER_FORM_BATCHES,
        payload: response.data,
      })
      // dispatch(fetchSalesOrderProductByIDSuccesful(response));
    }, (err) => {
      alert(JSON.stringify(err.data));
      // if (err.status === 500 || err.status === 404) {
      //   err.data = DEFAULT_ERROR;
      // }
      // dispatch(fetchSalesOrderProductByIDFailure(err));
    });
}

export const fetchProductPromotion = (product_id, customer, success = () => {}) => dispatch => {
  dispatch({
    type: 'salesOrderForm/productpromotionfetching',
  })
  let url = `${PROMOTIONS_URL}?Product_id=${product_id}`;
  axios.get(
    url,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    },
  )
    .then((response) => {
      // console.log('response', response, dispatch);
      dispatch({
        type: 'salesOrderForm/productpromotion',
        payload: response.data.promotions,
      });
      success();
      // dispatch(fetchSalesOrderProductByIDSuccesful(response));
    }, (err) => {
      // if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      //   document.getElementById('tokenInvalid').style.display = 'flex'
      //   return
      // }
      // if (err.status === 500 || err.status === 404) {
      //   err.data = DEFAULT_ERROR;
      // }
      // dispatch(fetchSalesOrderProductByIDFailure(err));
    });
}

export function fetchSalesOrderProductByIDSuccesful(product) {
  return {
    type: FETCH_PRODUCT_BY_ID_SUCCESS,
    payload: product,
  };
}

export function fetchSalesOrderProductByIDFailure(error) {
  return {
    type: FETCH_PRODUCT_BY_ID_FAILURE,
    payload: error,
  };
}

export function initializeSalesOrderForm(type, Form) {
  return (dispatch) => {
    dispatch(change(Form, 'searchType', type));
    dispatch(change(Form, 'Quantity', 1));
  };
}

export function printSalesOrderSI(salesInvoiceID) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SO_SI_PDF });
    return axios.get(
      SO_PRINT_SALES_INVOICE_URL + salesInvoiceID,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch({
          type: FETCH_SO_SI_PDF_SUCCESS,
          payload: response,
        });
      }, (err) => {
        console.log('ERROR IN response', err);
      });
  };
}

export function printSalesOrder(salesOrder_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SO_PDF });
    return axios.get(
      SALES_ORDER_PRINT_URL + salesOrder_id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderPDFSuccess(response));
      }, (err) => {
        console.log('ERROR IN response', err);
      });
  };
}

export function printSalesOrderLabel(salesOrder_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SO_PDF });
    return axios.get(
      SALES_ORDER_LABEL_PRINT_URL + salesOrder_id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderPDFSuccess(response));
      }, (err) => {
        console.log('ERROR IN response', err);
      });
  };
}

export function printSalesOrderLabelBOL(salesOrder_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SO_PDF });
    return axios.get(
      WIZ_PRINT_BOL + salesOrder_id + '?mode=pdf',
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderPDFSuccess(response));
      }, (err) => {
        console.log('ERROR IN response', err);
      });
  };
}

export function printSalesOrderLabelDSQ(salesOrderLine_ids) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SO_PDF });
    return axios.get(
      SALES_ORDER_LABEL_PRINT_URL + salesOrderLine_ids,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderPDFSuccess(response));
      }, (err) => {
        console.log('ERROR IN response', err);
      });
  };
}

export function printShippigLabel(salesOrder_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SO_PDF });
    return axios.get(
      PRINT_SHIPPING_LABEL_URL + salesOrder_id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
    .then((response) => {
      dispatch(fetchSalesOrderPDFSuccess(response));
    })
    .catch((err) => {
      axios.get(
        PRINT_SHIPPING_LABEL_URL + salesOrder_id,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }
      )
      .then((response) => {
      }, (error) => {
        alert('Error printing shippng lable: ' + error.data);
      });
    });
  };
}

export function printSalesOrderLabelBatch(salesOrder_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SO_PDF });
    return axios.post(
      SALES_ORDER_LABEL_PRINT_URL_BATCH,
      {
        salesOrder_id,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderPDFSuccess(response));
      }, (err) => {
        console.log('ERROR IN response', err);
      });
  };
}

export function fetchSalesOrderPDFSuccess(FileData) {
  return {
    type: FETCH_SO_PDF_SUCCESS,
    payload: FileData,
  };
}

// export function removeSalesOrderPDF() {
//   return {
//     type: REMOVE_SHIPPING_PDF
//   }
// }

export function printShippingList(salesOrder_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SHIPPING_LIST_PDF });
    return axios.get(
      SHIPPING_LIST_URL + salesOrder_id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchShippingListPDFSuccess(response));
      }, (err) => {
        console.log('ERROR IN response', err);
      });
  };
}

export function printReceivingReport(salesOrder_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SHIPPING_LIST_PDF });
    return axios.get(
      RECEIVING_REPORT_URL + salesOrder_id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchShippingListPDFSuccess(response));
      }, (err) => {
        alert("Could not fetch Receiving Report");
        console.log('ERROR IN response', err);
      });
  };
}

export function printYingBOL(salesOrder_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SHIPPING_LIST_PDF });
    return axios.get(
      YING_BOL_URL + salesOrder_id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchShippingListPDFSuccess(response));
      }, (err) => {
        alert("Could not fetch BOL");
        console.log('ERROR IN response', err);
      });
  };
}


export function printYingCustomerFile(salesOrder_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SHIPPING_LIST_PDF });
    return axios.get(
      YING_CUSTOMER_FILE + salesOrder_id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchShippingListPDFSuccess(response));
      }, (err) => {
        alert("Could not fetch File");
        console.log('ERROR IN response', err);
      });
  };
}

export function printShippingListATL(salesOrder_id) {
  let data = {pk: salesOrder_id};
  return (dispatch) => {
    dispatch({ type: REQUEST_SHIPPING_LIST_PDF });
    return axios.post(
      SHIPPING_LIST_URL + 'shippinglist',
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchShippingListPDFSuccess(response));
      }, (err) => {
        console.log('ERROR IN response', err);
      });
  };
}

export function fetchShippingListPDFSuccess(FileData) {
  return {
    type: FETCH_SHIPPING_LIST_SUCCESS,
    payload: FileData,
  };
}

export function printPickingList(salesOrder_id) {
  if (salesOrder_id) {
    return (dispatch) => {
      dispatch({ type: REQUEST_PICKING_LIST_PDF });
      return axios.get(
        PICKING_LIST_URL + salesOrder_id,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          responseType: 'blob',
        },
      )
        .then((response) => {
          dispatch(fetchPickingListPDFSuccess(response));
        }, (err) => {
          console.log('ERROR IN response', err);
        });
    };
  }
}

export function printPickingListPartial(label) {
  if (label) {
    return (dispatch) => {
      dispatch({ type: REQUEST_PICKING_LIST_PDF });
      return axios.get(
        `${ROOT_URL}v2/sale/partial_picking_list/${label}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          responseType: 'blob',
        },
      )
        .then((response) => {
          dispatch(fetchPickingListPDFSuccess(response));
        }, (err) => {
          console.log('ERROR IN response', err);
        });
    };
  }
}

export function printPickingListATL(salesOrder_id) {
  // if (salesOrder_id) {
    let data = {pk: salesOrder_id};
    return (dispatch) => {
      dispatch({ type: REQUEST_PICKING_LIST_PDF });
      return axios.post(
        PACKING_LIST_URL + 'driverlist',
        data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          responseType: 'blob',
        },
      )
        .then((response) => {
          dispatch(fetchPickingListPDFSuccess(response));
        }, (err) => {
          console.log('ERROR IN response', err);
        });
    };
  // }
}

export function printPickingListAFG(salesOrder_id, users, sort) {
  if (users === '0' || !users) {
    users = 1;
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_PICKING_LIST_PDF });
    return axios.get(
      PICKING_LIST_URL + salesOrder_id + '?assign=' + users + '&orderBy=' + sort,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchPickingListPDFSuccess(response));
      }, (err) => {
        console.log('ERROR IN response', err);
      });
  };
}

export function fetchPickingListPDFSuccess(FileData) {
  return {
    type: FETCH_PICKING_LIST_SUCCESS,
    payload: FileData,
  };
}

export function printPackingList(salesOrder_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PACKING_LIST_PDF });
    return axios.get(
      PACKING_LIST_URL + salesOrder_id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchPackingListPDFSuccess(response));
      }, (err) => {
        console.log('ERROR IN response', err);
      });
  };
}

export function printPackingListATL(salesOrder_id) {
  let data = {pk: salesOrder_id};
  return (dispatch) => {
    dispatch({ type: REQUEST_PACKING_LIST_PDF });
    return axios.post(
      PICKING_LIST_URL + 'pickinglist',
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchPackingListPDFSuccess(response));
      }, (err) => {
        console.log('ERROR IN response', err);
      });
  };
}

export function fetchPackingListPDFSuccess(FileData) {
  return {
    type: FETCH_PACKING_LIST_SUCCESS,
    payload: FileData,
  };
}


function fetchMSORefundPDFSuccess(FileData) {
  return {
    type: REQUEST_REFUND_PDF_SUCCESS,
    payload: FileData,
  };
}

export function printMSORefundPDF(salesOrderID) {
  return (dispatch) => {
    dispatch({ type: REQUEST_REFUND_PDF });
    const token = localStorage.getItem('token');
    return axios({
      method: 'get',
      url: `${REFUND_SUMMARY_URL}${salesOrderID}`,
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob',
    }).then((response) => {
      dispatch(fetchMSORefundPDFSuccess(response));
    }, (err) => {
      console.log('ERROR IN response', err);
    });
  };
}

export function fetchSalesTotalsSuccess(totals) {
  return {
    type: FETCH_SALES_TOTALS_SUCCESS,
    payload: totals,
  };
}

export function fetchSalesTotalsFailure(error) {
  return {
    type: FETCH_SALES_TOTALS_FAILURE,
    payload: error,
  };
}

export function fetchSalesTotals(type) {
  const start_date = moment().toISOString();
  return (dispatch) => {
    dispatch({ type: REQUEST_SALES_TOTALS });
    return axios({
      method: 'get',
      url: OVERALL_SALES_PERFORMANCE_URL,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: {
        type,
        start_date,
      },
    }).then((response) => {
      dispatch(fetchSalesTotalsSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(fetchSalesTotalsFailure(err));
    });
  };
}

export function orderToQuote(salesId) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SALES_ORDER_TO_QUOTE });
    return axios({
      method: 'PUT',
      url: `${QUOTE_TO_ORDER_URL}so_to_sq/` + salesId,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      }
    )
    .then(response => {
      dispatch(orderToQuoteSuccess(response));
    }, (err) => {
      dispatch(orderToQuoteFailure(err));
    });
  };
}

export function orderToQuoteSuccess(response) {
  return {
    type: SALES_ORDER_TO_QUOTE_SUCCESS
  };
}

export function orderToQuoteFailure(err) {
  return {
    type: SALES_ORDER_TO_QUOTE_FAILURE,
    payload: err,
  };
}


export function quoteToOrder(salesId) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SALES_QUOTE_TO_OPEN });
    return axios({
      method: 'PUT',
      url: `${QUOTE_TO_ORDER_URL}sq_to_so/` + salesId,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      }
    )
    .then(response => {
      dispatch(quoteToOrderSuccess(response));
    }, (err) => {
      dispatch(quoteToOrderFailure(err));
    });
  };
}

export function quoteToOrderSuccess(response) {
  return {
    type: REQUEST_SALES_QUOTE_TO_ORDER_SUCCESS
  };
}

export function quoteToOrderFailure(err) {
  return {
    type: REQUEST_SALES_QUOTE_TO_ORDER_FAILURE,
    payload: err,
  };
}

export function emailSO(salesOrder_id) {
  return (dispatch) => {
    axios.get(
      `${ROOT_URL}v1/sale/emailorder/${salesOrder_id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      }
    )
      .then((response) => {
        alert(JSON.stringify(response.data));
      }, (err) => {
        alert(JSON.stringify(err.data));
      });
    };
}


export function emailSOCalco(salesOrder_id, subject, content, email, phone, email_to) {
  // let data = {subject, content, email_to};
  let data = {};
  return (dispatch) => {
    axios.post(
      `${ROOT_URL}v1/sale/emailorder/${salesOrder_id}`,
      // { subject, content },
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      }
    )
      .then((response) => {
        alert(JSON.stringify(response.data));
      }, (err) => {
        alert(JSON.stringify(err.data));
      });
    };
}


export function createMobileTask(salesOrder_id) {
  return (dispatch) => {
    dispatch({ type: CREATE_MOBILE_TASK });
    axios.post(
      `${MOBILE_SALES_ORDERS_URL}create_onfleet_task/${salesOrder_id}`, {},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      }
    )
      .then((response) => {
        alert(JSON.stringify(response.data));
        dispatch(createMobileTaskSuccess(response));
      }, (err) => {
        alert(JSON.stringify(err.data));
        dispatch(createMobileTaskFailure(err));
      });
    };
}

export function createMobileTaskSuccess(response) {
  return {
    type: CREATE_MOBILE_TASK_SUCCESS,
  };
}

export function createMobileTaskFailure(err) {
  return {
    type: CREATE_MOBILE_TASK_FAILURE,
    payload: err,
  };
}

// export function requestSetShippingWeight() {
//   return {
//     type: REQUEST_SET_SHIPPING_WEIGHT,
//   };
// }

export function updateShippingWeightSuccess(data) {
  return {
    type: UPDATE_SHIPPING_WEIGHT_SUCCESS,
    // payload: data,
  };
}

export function updateShippingWeightFailure(error) {
  return {
    type: UPDATE_SHIPPING_WEIGHT_FAILURE,
    payload: error,
  };
}

export function updateShippingWeight(salesOrder_id, finalShippingWeight) {
  let output = {
    finalShippingWeight: Number(finalShippingWeight)
  }
  const url = `${PATCH_SALES_ORDER_WEIGHT_URL}${salesOrder_id}`;
  return (dispatch) => {
    dispatch({ type: REQUEST_SET_SHIPPING_WEIGHT });
    return axios({
      method: 'patch',
      url: url,
      data: output,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((response) => {
        // alert(JSON.stringify(response.data));
        // alert(JSON.stringify('Shipping Weight Patched Successfully'));
        dispatch(updateShippingWeightSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
          alert(JSON.stringify(err.data));
        }
        dispatch(updateShippingWeightFailure(err));
      });
  };
}

export function updateShippingWeightSplit(salesOrder_id, splitWeightArray) {
  let output = [];
  splitWeightArray.map(r => {
    if (!isFinite(r.Package_Weight)) {
      alert("\"" + r.Package_Weight + "\" is not a number and has been omitted!");
    }
    if (r.Package_Weight && isFinite(r.Package_Weight)) {
      output.push({ Package_Weight: Number(r.Package_Weight), Package_Note: r.Package_Note ? r.Package_Note : "", Tracking_Number: r.Tracking_Number ? r.Tracking_Number : "", recreate: r.recreate });
    }
  });
  if (output.length === 0) {
    alert("Must have at least one valid pack weight.");
    return;
  }
  const url = `${PATCH_SALES_ORDER_WEIGHT_MULTI_URL}${salesOrder_id}`;
  return (dispatch) => {
    dispatch({ type: REQUEST_SET_SHIPPING_WEIGHT_SPLIT });
    return axios({
      method: 'patch',
      url: url,
      data: output,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((response) => {
        // alert(JSON.stringify(response.data));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
          alert(JSON.stringify(err.data));
        }
      });
  };
}

export function fetchShippingWeightTracking(salesOrder_id) {
  const url = `${FETCH_SALES_ORDER_WEIGHT_TRACKING}${salesOrder_id}`;
  return (dispatch) => {
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function fetchCarrierInfo(salesOrder_id) {
  const url = `${CARRIER_INFO_URL}${salesOrder_id}`;
  return (dispatch) => {
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function postCarrierInfo(salesOrder_id, output) {
  const url = `${CARRIER_INFO_URL}${salesOrder_id}`;
  return (dispatch) => {
    return axios({
      method: 'post',
      url: url,
      data: output,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function fetchJmlTracking(salesOrder_id) {
  const url = `${FETCH_JML_TRACKING_NUMBER_URL}${salesOrder_id}`;
  return (dispatch) => {
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function updateEmployeeNote(salesOrder_id, employeeNoteText) {
  let output = {
    EmployeeNote: employeeNoteText
  }
  const url = `${PATCH_SALES_EMPLOYEE_NOTE_URL}${salesOrder_id}`;
  return (dispatch) => {
    return axios({
      method: 'patch',
      url: url,
      data: output,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function updateVoidNote(salesOrder_id, voidString) {
  let output = {
    VoidNote: voidString
  }
  const url = `${PATCH_SALES_VOID_NOTE_URL}${salesOrder_id}`;
  return (dispatch) => {
    return axios({
      method: 'patch',
      url: url,
      data: output,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function reshipOrder(salesOrder_id) {
  const url = `${SALES_ORDER_RESHIP_URL}${salesOrder_id}/`;
  return (dispatch) => {
    return axios({
      method: 'put',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
    .then((response) => {
      // alert(JSON.stringify(response.data));
      alert("Order has been reshipped!");
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        // err.data = DEFAULT_ERROR;
      }
      alert("Reshipping failed: " + err);
    });
  };
}

export function setQuoteOrder(salesOrder_id, customer_id) {
  const url = `${SET_QUOTE_URL}${salesOrder_id}/${customer_id}`;
  return (dispatch) => {
    return axios({
      method: 'put',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
    .then((response) => {
      // alert(JSON.stringify(response.data));
      // alert("Quotes set to Orders!");
    }, (err) => {
      console.log("err", err);
      if (err.status === 500 || err.status === 404) {
        // err.data = DEFAULT_ERROR;
      }
      alert("Quote to order failed: " + err.data);
    });
  };
}

export function setDavisPO(salesOrder_id) {
  const url = `${SO_TO_PO_DAVIS_URL}`;
  let data = {SalesOrder_id: salesOrder_id};
  return (dispatch) => {
    return axios({
      method: 'post',
      url: url,
      data: data,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
    .then((response) => {
      // alert(JSON.stringify(response.data));
      alert("Sent to Davis PO: " + response.data);
    }, (err) => {
      console.log("err", err);
      if (err.status === 500 || err.status === 404) {
        // err.data = DEFAULT_ERROR;
      }
      alert("SO to PO failed: " + err.data);
    });
  };
}

/**
  * Gets previously set product images
  *
  * @param {Number} salesOrder_id
  * @param {func} handleSuccess
  * @param {func} handleFailure
  */
export const fetchBolImage = (salesOrder_id, handleSuccess, handleFailure) => {
  const token = localStorage.getItem('token');
  const config = {
    method: 'get',
    url: `${MOBILE_SALES_ORDERS_URL}?pk=${salesOrder_id}`,
  };
  axios({
    ...config,
    headers: { Authorization: `Bearer ${token}` },
  }).then((response) => {
    handleSuccess(response.data);
  }, (err) => {
    if (err.status === 500 || err.status === 404) {
      err.data = DEFAULT_ERROR;
    }
    handleFailure(err.data);
  });
};

export const fetchBolImageOCM = (salesOrder_id, handleSuccess, handleFailure) => {
  const token = localStorage.getItem('token');
  const config = {
    method: 'get',
    url: `${ROOT_URL}v1/sale/sales_order/?pk=${salesOrder_id}`,
  };
  axios({
    ...config,
    headers: { Authorization: `Bearer ${token}` },
  }).then((response) => {
    handleSuccess(response.data);
  }, (err) => {
    if (err.status === 500 || err.status === 404) {
      err.data = DEFAULT_ERROR;
    }
    handleFailure(err.data);
  });
}

/**
  * Delete previously saved image
  *
  * @param {Number} imageId
  * @param {func} handleSuccess
  * @param {func} handleFailure
  */
export const deleteBolImage = (imageId, handleSuccess, handleFailure) => {
  const token = localStorage.getItem('token');
  const config = {
    method: 'delete',
    url: `${OVERSEA_DELETE_BOL_IMAGE_URL}${imageId}`,
  };
  axios({
    ...config,
    headers: { Authorization: `Bearer ${token}` },
  }).then((response) => {
    handleSuccess(response.data);
  }, (err) => {
    if (err.status === 500 || err.status === 404) {
      err.data = DEFAULT_ERROR;
    }
    handleFailure(err.data);
  });
};

export const deleteBolImageSCM = (imageId, handleSuccess, handleFailure) => {
  const token = localStorage.getItem('token');
  const config = {
    method: 'delete',
    url: `${ROOT_URL}v1/sale/so_images_delete/${imageId}`,
  };
  axios({
    ...config,
    headers: { Authorization: `Bearer ${token}` },
  }).then((response) => {
    handleSuccess(response.data);
  }, (err) => {
    if (err.status === 500 || err.status === 404) {
      err.data = DEFAULT_ERROR;
    }
    handleFailure(err.data);
  });
}
/**
  * Updates product images
  *
  * @param {Number} salesOrder_id
  * @param {func} handleSuccess
  * @param {func} handleFailure
  */
export const submitBolImage = (salesOrder_id, images, handleSuccess, handleFailure) => {
  const url = `${OVERSEA_UPLOAD_BOL_IMAGE_URL}${salesOrder_id}`;
  
  let data = new FormData();
  for (let i = 0; i < images.length; i++) {
    data.append('image', images[i].file[0]);
  }
  
  const config = {
    method: 'post',
    url: `${OVERSEA_UPLOAD_BOL_IMAGE_URL}${salesOrder_id}`,
    data,
  };
  axios({
    ...config,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then((response) => {
    handleSuccess(response.data);
  }, (err) => {
    if (err.status === 500 || err.status === 404) {
      // err.data = DEFAULT_ERROR;
    }
    handleFailure(err.data);
  });
};

export const submitBolImageSCM = (salesOrder_id, images, handleSuccess, handleFailure) => {
  const url = `${ROOT_URL}v1/sale/upload_so_images/${salesOrder_id}`
  
  let data = new FormData();
  for (let i = 0; i < images.length; i++) {
    data.append('images', images[i].file[0]);
  }
  
  const config = {
    method: 'post',
    url,
    data,
  };
  axios({
    ...config,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then((response) => {
    handleSuccess(response.data);
  }, (err) => {
    if (err.status === 500 || err.status === 404) {
      // err.data = DEFAULT_ERROR;
    }
    handleFailure(err.data);
  });
};

export function fetchBolByIdPDFSuccess(FileData) {
  return {
    type: FETCH_BOL_ID_PDF_SUCCESS,
    payload: FileData,
  };
}

export function printBolById(salesOrder_id) {
  if (salesOrder_id) {
    return (dispatch) => {
      dispatch({ type: REQUEST_BOL_ID_PDF });
      return axios.get(
        OVERSEA_PRINT_BOL_URL + salesOrder_id,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          responseType: 'blob',
        },
      )
        .then((response) => {
          dispatch(fetchBolByIdPDFSuccess(response));
        }, (err) => {
          console.log('Print Bol failed', err);
        });
    };
  }
}

export function fetchPrintBolWithoutLogSuccess(FileData) {
  return {
    type: FETCH_BOL_WITHOUT_LOG_SUCCESS,
    payload: FileData,
  };
}

export function printBolWithoutLog(salesOrder_id) {
  if (salesOrder_id) {
    return (dispatch) => {
      dispatch({ type: REQUEST_BOL_WITHOUT_LOG });
      return axios.get(
        OVERSEA_PRINT_BOL_WITHOUT_LOG_URL + salesOrder_id,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          responseType: 'blob',
        },
      )
        .then((response) => {
          dispatch(fetchBolByIdPDFSuccess(response));
        }, (err) => {
          console.log('Print Bol failed', err);
        });
    };
  }
}

export function fetchPrintBolLabelSuccess(FileData) {
  return {
    type: FETCH_BOL_LABEL_SUCCESS,
    payload: FileData,
  };
}

export function printBolLabel(salesOrder_id) {
  if (salesOrder_id) {
    return (dispatch) => {
      dispatch({ type: REQUEST_BOL_LABEL });
      return axios.get(
        OVERSEA_PRINT_BOL_LABEL_URL + salesOrder_id,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          responseType: 'blob',
        },
      )
        .then((response) => {
          dispatch(fetchPrintBolLabelSuccess(response));
        }, (err) => {
          console.log('Print Bol label failed', err);
        });
    };
  }
}

export function fetchBolByFbaPDFSuccess(FileData) {
  return {
    type: FETCH_BOL_FBA_PDF_SUCCESS,
    payload: FileData,
  };
}

export function printBolByFba(fba_code) {
  if (fba_code) {
    return (dispatch) => {
      dispatch({ type: REQUEST_BOL_FBA_PDF });
      return axios.get(
        `${OVERSEA_PRINT_BOL_URL}?FBACode=${fba_code}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          responseType: 'blob',
        },
      )
        .then((response) => {
          dispatch(fetchBolByFbaPDFSuccess(response));
        }, (err) => {
          if (err.status === 400) {
            alert('cannot find sales order');
          }
          console.log('Print Bol failed', err);
        });
    };
  }
}

export function fetchSPSuccess(FileData) {
  return {
    type: FETCH_SP_SUCCESS,
    payload: FileData,
  };
}

export function printSP(days, fromDate, toDate) {
  const dates = toFromDates(days, fromDate, toDate);

  let psfromDate = `date__gte=${dates.fromDate}`;
  let pstoDate = `date__lte=${dates.toDate}`;

  let belongWarehouse = ``;
  if ( isAFM ){
    if (!localStorage.getItem('warehouseLocation') || localStorage.getItem('warehouseLocation') === '') {
      belongWarehouse = ``;
    } else {
      belongWarehouse = `&BelongWarehouse=${localStorage.getItem('warehouseLocation')}`;
    }
  }

    return (dispatch) => {
      dispatch({ type: REQUEST_SP_PDF });
      return axios.get(
        `${SP_PDF_URL}?${psfromDate}&${pstoDate}${belongWarehouse}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          responseType: 'blob',
        },
      )
        .then((response) => {
          dispatch(fetchSPSuccess(response));
        }, (err) => {
          if (err.status === 400) {
            alert('fetch failed');
          }
        });
    };
}

export function fetchBolAddressSuccess(address) {
  return {
    type: FETCH_BOL_ADDRESS_SUCCESS,
    payload: address,
  };
}

export function fetchBolAddress() {
  return (dispatch) => {
    return axios.get(
      OVERSEA_ADDRESS_URL,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
      .then((response) => {
        dispatch(fetchBolAddressSuccess(response));
      }, (err) => {
        console.log('fetch Bol Address failed:', err);
      });
  };
}

export function chowbusImport(file) {
  const url = `${CHOWBUS_IMPORT}`;
  return (dispatch) => {
    return axios({
      method: 'post',
      url: url,
      data: file,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function getPaymentTerms() {
  const url = `${PAYMENT_URL}`;
  return (dispatch) => {
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function fetchFJAgents(customer) {
  const url = `${FETCH_FJ_AGENTS_URL}${customer}`;
  return (dispatch) => {
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function fetchFJCarriers() {
  const url = `${FETCH_FJ_CARRIERS_URL}`;
  return (dispatch) => {
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function fetchFBAAddressOptions() {
  const url = `${FETCH_FBA_ADDRESS_URL}`;
  return (dispatch) => {
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function fetchCompany() {
  const url = `${COMPANY_URL}`;
  return (dispatch) => {
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}

export function fetchWarehousesByCompany(id) {
  const url = `${WAREHOUSE_BY_COMPANY_URL}${id}`;
  return (dispatch) => {
    return axios({
      method: 'get',
      url: url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
  };
}


export function selectTeapplixShipping(method, salesOrderId, success = () => {}) {
  return (dispatch) => {
  dispatch({ type: REQUEST_SO_PDF });
    return axios.post(
      `${ROOT_URL}v2/shipping/teapplix_label/${salesOrderId}`,
      {
        'shipping_method': method
      },{
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        success();
        dispatch(printTeapplixLabel(salesOrderId));
      }, (err) => {
        dispatch(fetchSalesOrderPDFSuccess([]));
        alert('Failed on select teapplix label: ' + JSON.stringify(err.data));
      });
  };
}

export function printTeapplixLabel(salesOrder_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SO_PDF });
    return axios.get(
      `${ROOT_URL}v2/shipping/teapplix_label/${salesOrder_id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderPDFSuccess(response));
      }, (err) => {
        dispatch(fetchSalesOrderPDFSuccess([]));
        alert('No label, please make sure to select your shipping method');
      });
  };
}

export function deleteTeapplixShipping(salesOrder_id, success) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SO_PDF });
    return axios.delete(
      `${ROOT_URL}v2/shipping/teapplix_label/${salesOrder_id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderPDFSuccess([]));
        success();
      }, (err) => {
        dispatch(fetchSalesOrderPDFSuccess([]));
        alert('Failed on delete teapplix label: '+ err.data);
      });
  };
}



// WEBPACK FOOTER //
// ./master/jsx/actions/sales_actions.js